import React, { useState, useEffect, useRef, useMemo } from "react";
import { db } from "../firebase/config";
import { collection, getDocs, query, where, doc, updateDoc, onSnapshot } from "firebase/firestore";
import { Plus, Search, FileText, Loader2, Trash2, Award, Ban, ChevronDown, ChevronUp, Move, HelpCircle, RefreshCw, MessageSquare, Sliders, Info, Link, CheckSquare, ListPlus, ArrowUp, ArrowDown, RotateCcw, GripVertical, Edit3, CheckCircle, AlertTriangle } from "lucide-react";
import { usePOs } from "../hooks/usePOs";
import { deleteEstimateCompletely } from "../services/poService";
import AdditionalInfoModal from "../components/modals/AdditionalInfoModal";
import { useLocation } from "react-router-dom";
import { useCustomers } from "../hooks/useCustomers";
import { useLogistics } from "../hooks/useLogistics";
import { useVendors } from "../hooks/useVendors";
import { useAuth } from "../context/AuthContext";
import POReceiveModal from "../components/modals/POReceiveModal";
import POMarkupModal from "../components/modals/POMarkupModal";
import ShippingCostOutModal from "../components/modals/ShippingCostOutModal";
import POSubmitBidModal from "../components/modals/POSubmitBidModal";
import POStatusModal from "../components/modals/POStatusModal";
import POTagSearchModal from "../components/modals/POTagSearchModal";
import POUrlModal from "../components/modals/POUrlModal";
import POAddCustomerModal from "../components/modals/POAddCustomerModal";
import UpdateBidModal from "../components/modals/UpdateBidModal";
import { useCompanyLogos } from "../hooks/useCompanyLogos";
import { calculateVendorShippingMultipliers, recalculateItemClientPrice, recalculateAllPoItemClientPrices, calculateTotalShippingSum, calculateLineTotalCost, calculateTotalCostSum, getDefaultTaxRate, calculateBaseTotalEstimateAmount, calculateNewDecimal, getPoShippingCostOut } from "../utils/pricingUtils";
import POTeamsChatModal from "../components/modals/POTeamsChatModal";
import ChangeRequestModal from "../components/modals/ChangeRequestModal";
import POLineMarkupModal from "../components/modals/POLineMarkupModal";
import POTasksModal from "../components/modals/POTasksModal";
import DeleteEstimateConfirmationModal from "../components/modals/DeleteEstimateConfirmationModal";
import POLineNotesModal from "../components/modals/POLineNotesModal";
import { openDocumentPrintWindow } from "../utils/pdfExportUtils";
import { addCalendarDays } from "../utils/dateUtils";
import { detectCompanyKey, generateNextCompanyPoNumber, checkPoNumberExists, getGuaranteedNextPoNumber, isStandardGeneratedPoNumber } from "../utils/poNumberUtils";
import { logSecurityEvent } from "../services/AuditLogger";


function DescriptionCell({ poId, item, isReadOnly, handleUpdateItemFieldLocal, handleSyncItemsToFirestore }) {
  const textareaRef = useRef(null);

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [item.description]);

  return (
    <textarea
      ref={textareaRef}
      rows={1}
      className="inline-edit-input"
      value={item.description}
      disabled={isReadOnly}
      placeholder="Enter description..."
      onChange={(e) => {
        handleUpdateItemFieldLocal(poId, item.id, "description", e.target.value);
        adjustHeight();
      }}
      onBlur={() => handleSyncItemsToFirestore(poId)}
      style={{
        resize: "none",
        overflowY: "hidden",
        minHeight: "36px",
        wordBreak: "break-word",
        whiteSpace: "pre-wrap",
        padding: "0.4rem 0.5rem",
        lineHeight: "1.4",
        display: "block",
        width: "100%",
        boxSizing: "border-box"
      }}
    />
  );
}

export default function PO() {
  const { currentUser } = useAuth();
  const location = useLocation();
  const [procurementUsers, setProcurementUsers] = useState([
    { value: "alex", label: "Alex Mercer" },
    { value: "sarah", label: "Sarah Connor" },
    { value: "john", label: "John Doe" },
    { value: "david", label: "David Miller" },
    { value: "emily", label: "Emily Watson" }
  ]);


    const [addCustomerModalOpen, setAddCustomerModalOpen] = useState(false);
  const [customerForm, setCustomerForm] = useState({
    name: "",
    category: "Enterprise",
    status: "Active",
    address: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    billAddress: "",
    billAddress2: "",
    billCity: "",
    billState: "",
    billZip: "",
    shipAddress: "",
    shipAddress2: "",
    shipCity: "",
    shipState: "",
    shipZip: "",
    markFor: "",
    pocs: [{ name: "", title: "", email: "", phone: "" }]
  });


  // Markup Modal States
  const [markupModalOpen, setMarkupModalOpen] = useState(false);
  const [markupPo, setMarkupPo] = useState(null);
  const [tempMarkupRate, setTempMarkupRate] = useState(15);

  // Shipping Cost Out Modal States
  const [shippingCostOutModalOpen, setShippingCostOutModalOpen] = useState(false);
  const [selectedShippingPo, setSelectedShippingPo] = useState(null);
  const [tempShippingCostOut, setTempShippingCostOut] = useState("");
  const [shippingCostOutSubmitting, setShippingCostOutSubmitting] = useState(false);
  const [shippingCostOutError, setShippingCostOutError] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [companyFilter, setCompanyFilter] = useState("All");

  const [modalOpen, setModalOpen] = useState(false);
  const [editingPoId, setEditingPoId] = useState(null);
  const [expandedPoId, setExpandedPoId] = useState(null); // Track which row is folded open
  const [selectedChatPo, setSelectedChatPo] = useState(null);
  const [error, setError] = useState("");

  const { pos: serverPos, loading: posLoading, addPO, updatePO } = usePOs();
  const [pos, setPos] = useState([]);
  useEffect(() => {
    if (serverPos) {
      const unique = Array.from(new Map(serverPos.map(p => [p.id, p])).values());
      setPos(unique);
    }
  }, [serverPos]);

  useEffect(() => {
    if (location.state?.openPoId) {
      setExpandedPoId(location.state.openPoId);
      setActivePoTab("open");
    }
  }, [location.state]);
    const { customers, categories: customerCategories, paymentMethods, addCustomer } = useCustomers();
  const { vendors, availableTags, availableBrandTags } = useVendors();
  const { shipments, addShipment } = useLogistics();
  const [actionLoading, setActionLoading] = useState(false);
  const loading = posLoading || actionLoading;

  // Draggable columns state
  const [columnOrder, setColumnOrder] = useState([
    "lineNumber", "description", "quantity", "cuc", "unitPrice", "vendor", "tagSearch", "splitVendor", "vendorPrice", "tax", "shippingCost", "staff", "markupPercentage", "totalCharge", "actions"
  ]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);

  // Line item row drag-and-drop states
  const [draggedItemIndex, setDraggedItemIndex] = useState(null);
  const [dragOverItemIndex, setDragOverItemIndex] = useState(null);
  const [draggedItemPoId, setDraggedItemPoId] = useState(null);

  // New states for vendors, logo dropdown, tag search modal
  const { companyLogos } = useCompanyLogos();
  const [tagSearchModalOpen, setTagSearchModalOpen] = useState(false);
  const [tagSearchQuery, setTagSearchQuery] = useState("");
  const [selectedSearchTag, setSelectedSearchTag] = useState(null);
  const [tagSearchTarget, setTagSearchTarget] = useState(null); // { poId, itemId, vendorId }

  // URL modal states
  const [urlModalOpen, setUrlModalOpen] = useState(false);
  const [urlModalTarget, setUrlModalTarget] = useState(null); // { poId, itemId, vendorId, initialUrl, itemName, vendorName }


  // Submission modal and Tab states
  const [activePoTab, setActivePoTab] = useState("pipeline"); // "pipeline" | "open" | "completed"
  const [submitModalOpen, setSubmitModalOpen] = useState(false);
  const [submitPo, setSubmitPo] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitManagerNote, setSubmitManagerNote] = useState("");

  const getPoLogoUrl = (po) => {
    if (po.logoUrl) return po.logoUrl;
    const activeLogo = companyLogos.find(l => l.isActive);
    return activeLogo?.url || "";
  };

  const getCompanyNameForPo = (po) => {
    if (po?.companyName && typeof po.companyName === "string" && po.companyName.trim()) {
      return po.companyName.trim();
    }
    if (po?.logoUrl) {
      const logo = companyLogos.find(l => l.url === po.logoUrl);
      if (logo?.name) return logo.name;
    }
    const activeLogo = companyLogos.find(l => l.isActive);
    return activeLogo?.name || "No Company";
  };

  const availableCompanyNames = useMemo(() => {
    const set = new Set();
    (companyLogos || []).forEach(l => { if (l.name) set.add(l.name.trim()); });
    (pos || []).forEach(p => {
      const cName = getCompanyNameForPo(p);
      if (cName && cName !== "No Company" && cName !== "Unknown Company") {
        set.add(cName);
      }
    });
    return Array.from(set).sort();
  }, [companyLogos, pos]);

  // Status update modal states
  const [statusUpdateModalOpen, setStatusUpdateModalOpen] = useState(false);
  const [statusUpdatePo, setStatusUpdatePo] = useState(null);
  const [statusUpdateNewStatus, setStatusUpdateNewStatus] = useState("Won");
  const [awardedDate, setAwardedDate] = useState("");
  const [statusCustomerPo, setStatusCustomerPo] = useState("");
  const [updateBidPo, setUpdateBidPo] = useState(null);
  const [selectedChangeRequestPo, setSelectedChangeRequestPo] = useState(null);
  const [selectedTasksPo, setSelectedTasksPo] = useState(null);
  const [additionalInfoPo, setAdditionalInfoPo] = useState(null);
  const [tempAdditionalInfo, setTempAdditionalInfo] = useState("");
  const [additionalInfoModalOpen, setAdditionalInfoModalOpen] = useState(false);

  // Line item custom markup modal states
  const [customMarkupModalOpen, setCustomMarkupModalOpen] = useState(false);
  const [selectedMarkupItem, setSelectedMarkupItem] = useState(null);
  const [selectedMarkupPo, setSelectedMarkupPo] = useState(null);

  // Role permissions check
  const [currentUserRoles, setCurrentUserRoles] = useState([]);

  useEffect(() => {
    if (!currentUser || !currentUser.email) return;
    const q = query(collection(db, "users"), where("email", "==", currentUser.email));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        const userData = snapshot.docs[0].data();
        const roles = userData.roles || (userData.role ? [userData.role] : []);
        setCurrentUserRoles(roles);
      } else {
        setCurrentUserRoles([]);
      }
    }, (err) => {
      console.error("Error loading user roles in PO:", err);
    });
    return () => unsubscribe();
  }, [currentUser]);

  const isManagerOrAdmin = currentUserRoles.includes("Admin") || currentUserRoles.includes("Manager");
  const canDeleteEstimate = isManagerOrAdmin;

  // Delete Estimate Modal States
  const [deleteEstimateModalOpen, setDeleteEstimateModalOpen] = useState(false);
  const [estimateToDelete, setEstimateToDelete] = useState(null);
  const [isDeletingEstimate, setIsDeletingEstimate] = useState(false);

  const handleConfirmDeleteEstimate = async () => {
    if (!estimateToDelete) return;
    try {
      setIsDeletingEstimate(true);
      await deleteEstimateCompletely(estimateToDelete.id, estimateToDelete.poNumber, currentUser);
      setPos(prev => prev.filter(p => p.id !== estimateToDelete.id));
      if (expandedPoId === estimateToDelete.id) {
        setExpandedPoId(null);
      }
      setDeleteEstimateModalOpen(false);
      setEstimateToDelete(null);
    } catch (err) {
      console.error("Failed to delete estimate completely:", err);
      alert("Error deleting estimate: " + (err.message || "Unknown error occurred"));
    } finally {
      setIsDeletingEstimate(false);
    }
  };

  // Line item notes modal state
  const [lineNotesModal, setLineNotesModal] = useState({ open: false, po: null, item: null });

  const handleSaveLineNote = async (poId, itemId, noteText) => {
    const po = pos.find(p => p.id === poId);
    if (!po || !po.items) return;

    const author = currentUser?.displayName || currentUser?.email?.split('@')[0] || 'User';
    const newLog = {
      timestamp: new Date().toISOString(),
      text: noteText,
      type: "Estimate Note",
      source: "Procurement / Estimate",
      author
    };

    const updatedItems = po.items.map(item => {
      if (item.id !== itemId) return item;
      return {
        ...item,
        logs: [...(item.logs || []), newLog]
      };
    });

    await updatePO(po.id, { items: updatedItems });

    // Update local state in lineNotesModal so modal immediately reflects new note
    const updatedItem = updatedItems.find(i => i.id === itemId);
    setLineNotesModal(prev => ({ ...prev, item: updatedItem }));

    try {
      await logSecurityEvent({
        action: "ESTIMATE_LINE_NOTE_ADDED",
        category: "DATA_MODIFICATION",
        userId: currentUser?.uid || "anonymous",
        userEmail: currentUser?.email || "anonymous",
        resource: `pos/${po.id}/items/${itemId}`,
        status: "SUCCESS",
        details: {
          poNumber: po.poNumber,
          lineNumber: updatedItem?.lineNumber,
          itemDescription: updatedItem?.description,
          note: noteText
        }
      });
    } catch (logErr) {
      console.error("Failed to log estimate line note:", logErr);
    }
  };

  // Insert line popover menu state
  const [activeInsertMenu, setActiveInsertMenu] = useState(null); // { itemId, poId, index }

  useEffect(() => {
    if (!activeInsertMenu) return;
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".insert-line-popover-container")) {
        setActiveInsertMenu(null);
      }
    };
    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, [activeInsertMenu]);

  // Dropdown menu state for closing/rejecting open estimates
  const [activeCloseMenuId, setActiveCloseMenuId] = useState(null);

  useEffect(() => {
    if (!activeCloseMenuId) return;
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".close-estimate-dropdown-container")) {
        setActiveCloseMenuId(null);
      }
    };
    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, [activeCloseMenuId]);

  const isPoFullyDelivered = (poToCheck) => {
    if (!poToCheck || !poToCheck.items || poToCheck.items.length === 0) return false;
    const linkedShipment = shipments.find(s => s.poId === poToCheck.id);
    if (!linkedShipment) return false;
    return poToCheck.items.every(item => {
      const itemStatus = linkedShipment.itemStatuses?.[item.id]?.status || linkedShipment.status || "To Order";
      return itemStatus === "Delivered";
    });
  };

  useEffect(() => {
    async function fetchProcurementUsers() {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        const list = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.roles && data.roles.includes("Procurement") && !data.deleted && data.status !== "Disabled") {
            const val = data.email ? data.email.split("@")[0].toLowerCase() : (data.name ? data.name.toLowerCase() : doc.id);
            const name = data.name || data.fullName || (data.email ? data.email.split("@")[0] : "User");
            list.push({ value: val, label: name, email: data.email || "" });
          }
        });
        if (list.length > 0) {
          setProcurementUsers(list);
        }
      } catch (err) {
        console.error("Error fetching procurement users:", err);
      }
    }
    fetchProcurementUsers();
  }, []);

  const getStaffFullName = (staffVal) => {
    if (!staffVal) return "";
    const matched = procurementUsers.find(
      u => u.value?.toLowerCase() === staffVal.toLowerCase() || 
           u.label?.toLowerCase() === staffVal.toLowerCase() ||
           u.email?.toLowerCase() === staffVal.toLowerCase()
    );
    if (matched) return matched.label;
    return staffVal;
  };

  const getStaffInitials = (staffVal) => {
    const fullName = getStaffFullName(staffVal);
    if (!fullName) return "";
    const parts = fullName.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  

  

  



  

  useEffect(() => {
    // Customers list is automatically refreshed via the hook subscription
  }, [modalOpen]);

  // Load saved column order when user is available
  useEffect(() => {
    if (currentUser) {
      const savedOrder = localStorage.getItem(`po_columns_${currentUser.uid}`);
      if (savedOrder) {
        try {
          let parsed = JSON.parse(savedOrder);
          if (Array.isArray(parsed) && parsed.length > 0) {
            // Remove deprecated url column from user's saved preferences
            parsed = parsed.filter(col => col !== "url");
            const defaultCols = [
              "lineNumber", "description", "quantity", "cuc", "unitPrice", "vendor", "tagSearch", "splitVendor", "vendorPrice", "tax", "shippingCost", "staff", "markupPercentage", "totalCharge", "actions"
            ];
            const missingColumns = defaultCols.filter(col => !parsed.includes(col));
            if (missingColumns.length > 0) {
              let migrated = [...parsed];
              missingColumns.forEach(col => {
                if (col === "lineNumber") {
                  migrated.unshift(col);
                } else if (col === "cuc") {
                  const unitPriceIdx = migrated.indexOf("unitPrice");
                  if (unitPriceIdx !== -1) {
                    migrated.splice(unitPriceIdx, 0, col);
                  } else {
                    const quantityIdx = migrated.indexOf("quantity");
                    if (quantityIdx !== -1) {
                      migrated.splice(quantityIdx + 1, 0, col);
                    } else {
                      migrated.unshift(col);
                    }
                  }
                } else if (col === "tagSearch") {
                  const splitVendorIdx = migrated.indexOf("splitVendor");
                  if (splitVendorIdx !== -1) {
                    migrated.splice(splitVendorIdx, 0, col);
                  } else {
                    const vendorIdx = migrated.indexOf("vendor");
                    if (vendorIdx !== -1) {
                      migrated.splice(vendorIdx + 1, 0, col);
                    } else {
                      migrated.push(col);
                    }
                  }
                } else if (col === "splitVendor") {
                  const vendorIdx = migrated.indexOf("vendor");
                  if (vendorIdx !== -1) {
                    migrated.splice(vendorIdx + 1, 0, col);
                  } else {
                    migrated.push(col);
                  }
                } else if (col === "tax") {
                  const vendorPriceIdx = migrated.indexOf("vendorPrice");
                  if (vendorPriceIdx !== -1) {
                    migrated.splice(vendorPriceIdx + 1, 0, col);
                  } else {
                    const shippingCostIdx = migrated.indexOf("shippingCost");
                    if (shippingCostIdx !== -1) {
                      migrated.splice(shippingCostIdx, 0, col);
                    } else {
                      migrated.push(col);
                    }
                  }
                } else {
                  const actionsIdx = migrated.indexOf("actions");
                  if (actionsIdx !== -1) {
                    migrated.splice(actionsIdx, 0, col);
                  } else {
                    migrated.push(col);
                  }
                }
              });
              setColumnOrder(migrated);
              localStorage.setItem(`po_columns_${currentUser.uid}`, JSON.stringify(migrated));
            } else {
              setColumnOrder(parsed);
              localStorage.setItem(`po_columns_${currentUser.uid}`, JSON.stringify(parsed));
            }
          }
        } catch (e) {
          console.error("Failed to parse saved column order:", e);
        }
      }
    }
  }, [currentUser]);

  const columnHeaders = {
    lineNumber: "LN #",
    description: "Description",
    quantity: "Qty",
    cuc: "CUC",
    unitPrice: "Client Price",
    vendor: "Vendor",
    tagSearch: "",
    splitVendor: "",
    vendorPrice: "Unit Price",
    tax: "Tax",
    shippingCost: "VSC",
    staff: "Staff",
    markupPercentage: "MU %",
    totalCharge: "Total Cost",
    actions: ""
  };

  const columnStyles = {
    lineNumber: { width: "85px", textAlign: "center" },
    description: { minWidth: "150px" },
    quantity: { width: "70px", textAlign: "center" },
    cuc: { width: "100px", textAlign: "right" },
    unitPrice: { width: "110px", textAlign: "right" },
    vendor: { minWidth: "120px" },
    tagSearch: { width: "36px", textAlign: "center", padding: "0.25rem 0.1rem" },
    splitVendor: { width: "36px", textAlign: "center", padding: "0.25rem 0.1rem" },
    vendorPrice: { width: "110px", textAlign: "right" },
    tax: { width: "60px", textAlign: "center" },
    shippingCost: { width: "110px", textAlign: "right" },
    staff: { width: "65px", textAlign: "center", padding: "0.25rem 0.1rem" },
    markupPercentage: { width: "80px", textAlign: "center" },
    totalCharge: { width: "110px", textAlign: "right" },
    actions: { width: "40px", textAlign: "center" }
  };

  // Drag and Drop handlers
  function handleDragStart(e, index) {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
  }

  function handleDragOver(e, index) {
    e.preventDefault();
    if (dragOverIndex !== index) {
      setDragOverIndex(index);
    }
  }

  function handleDragEnd() {
    setDraggedIndex(null);
    setDragOverIndex(null);
  }

  function handleDrop(e, targetIndex) {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === targetIndex) return;

    const newOrder = [...columnOrder];
    const draggedCol = newOrder[draggedIndex];
    
    // Rearrange columns
    newOrder.splice(draggedIndex, 1);
    newOrder.splice(targetIndex, 0, draggedCol);

    setColumnOrder(newOrder);
    
    // Persist to localStorage scoped by user UID
    if (currentUser) {
      localStorage.setItem(`po_columns_${currentUser.uid}`, JSON.stringify(newOrder));
    }

    setDraggedIndex(null);
    setDragOverIndex(null);
  }

  // Row Drag and Drop handlers for line items (reorders items WITHOUT changing line numbers)
  function handleItemRowDragStart(e, poId, index) {
    setDraggedItemIndex(index);
    setDraggedItemPoId(poId);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", `${poId}:${index}`);
  }

  function handleItemRowDragOver(e, poId, index) {
    e.preventDefault();
    if (draggedItemPoId === poId && dragOverItemIndex !== index) {
      setDragOverItemIndex(index);
    }
  }

  function handleItemRowDragEnd() {
    setDraggedItemIndex(null);
    setDragOverItemIndex(null);
    setDraggedItemPoId(null);
  }

  async function handleItemRowDrop(e, poId, targetIndex) {
    e.preventDefault();
    if (draggedItemIndex === null || draggedItemPoId !== poId || draggedItemIndex === targetIndex) {
      handleItemRowDragEnd();
      return;
    }

    const po = pos.find(p => p.id === poId);
    if (!po || !po.items) {
      handleItemRowDragEnd();
      return;
    }

    const newItems = [...po.items];
    const [movedItem] = newItems.splice(draggedItemIndex, 1);
    newItems.splice(targetIndex, 0, movedItem);

    // CRITICAL: User requirement: "This will NOT change line numbers"
    // Each item's lineNumber remains untouched!

    handleItemRowDragEnd();

    // 1. Update state immediately for instant UI feedback
    setPos(prev => prev.map(p => p.id === poId ? { ...p, items: newItems } : p));

    // 2. Persist reordered array to Firestore
    try {
      await updatePO(poId, { items: newItems });
    } catch (err) {
      console.error("Failed to save reordered line items:", err);
    }
  }

  // Form state for creating a new PO request from client
  const [newPoForm, setNewPoForm] = useState({
    poNumber: "",
    customerPoNumber: "",
    clientName: "",
    title: "",
    receivedFromCustomerDate: new Date().toISOString().split("T")[0],
    date: new Date().toISOString().split("T")[0],
    dueDate: "",
    expirationDate: addCalendarDays(new Date().toISOString().split("T")[0], 30),
    status: "Received",
    isPriority: false,
    items: [],
    shipToAddress: "",
    shipToAddress2: "",
    shipToCity: "",
    shipToState: "",
    shipToZip: "",
    markFor: "",
    paymentMethod: "",
    logoUrl: ""
  });
  useEffect(() => {
    fetchPOs();
  }, []);

  async function fetchPOs() {
    try {
      setActionLoading(true);
      const querySnapshot = await getDocs(collection(db, "pos"));
      const list = [];
      querySnapshot.forEach((doc) => {
        list.push({ id: doc.id, ...doc.data() });
      });
      setPos(list);
    } catch (err) {
      console.error("Error fetching POs:", err);
    } finally {
      setActionLoading(false);
    }
  }

  const handleSelectCustomer = (customer) => {
    setNewPoForm({
      ...newPoForm,
      clientName: customer.name,
      shipToAddress: customer.shipAddress || customer.address || "",
      shipToAddress2: customer.shipAddress2 || customer.address2 || "",
      shipToCity: customer.shipCity || customer.city || "",
      shipToState: customer.shipState || customer.state || "",
      shipToZip: customer.shipZip || customer.zip || "",
      markFor: customer.markFor || ""
    });
    setShowCustomerSuggestions(false);
  };

  const addBusinessDays = (startDateStr, dueDays) => {
    try {
      const [yr, mo, dy] = startDateStr.split("-").map(Number);
      const date = new Date(yr, mo - 1, dy);
      let count = 0;
      while (count < dueDays) {
        date.setDate(date.getDate() + 1);
        const dayOfWeek = date.getDay(); // 0 = Sunday, 6 = Saturday
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          count++;
        }
      }
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    } catch {
      return startDateStr;
    }
  };

  const handleOpenSubmitModal = async (po) => {
    let currentPo = po;
    const nonBlankItems = (po.items || []).filter(item => item.description && item.description.trim() !== "");
    
    if (nonBlankItems.length !== (po.items || []).length) {
      try {
        await updatePO(po.id, { items: nonBlankItems });
        currentPo = { ...po, items: nonBlankItems };
        setPos(prev => prev.map(p => p.id === po.id ? currentPo : p));
      } catch (err) {
        console.error("Error auto-removing blank line items:", err);
      }
    }
    
    setSubmitPo(currentPo);
    setSubmitManagerNote(currentPo.managerApprovalNote || "");
    setIsSubmitted(currentPo.status === "Bid Submitted");
    setSubmitModalOpen(true);
  };

  const handleModalSubmitToClient = async () => {
    if (!submitPo) return;

    const totalMaterialCost = calculateTotalCostSum(submitPo.items);
    const totalEstimateAmount = calculateProposedClientCharge(submitPo);
    const projectedProfit = totalEstimateAmount - totalMaterialCost;
    const isLowProfit = projectedProfit <= 0.0001;

    if (isLowProfit) {
      if (!isManagerOrAdmin) {
        alert("Manager or Admin approval is required to submit an estimate with zero or negative projected profit.");
        return;
      }
      if (!submitManagerNote.trim()) {
        alert("Please provide a manager justification note explaining why zero or negative profit is permitted.");
        return;
      }
    }

    try {
      const nowStr = new Date().toISOString().split("T")[0];
      const updates = { 
        status: "Bid Submitted", 
        updateBidReason: "",
        submittedDate: submitPo.submittedDate || nowStr,
        ...(isLowProfit ? {
          managerApprovalNote: submitManagerNote.trim(),
          managerApprovedBy: currentUser?.displayName || currentUser?.email || "Manager",
          managerApprovedAt: new Date().toISOString(),
          managerApprovedRole: currentUserRoles.find(r => ["Admin", "Manager"].includes(r)) || "Manager"
        } : {})
      };

      if (isLowProfit && submitPo.items && submitPo.items.length > 0) {
        const author = currentUser?.displayName || currentUser?.email?.split('@')[0] || 'Manager';
        const approvalLog = {
          timestamp: new Date().toISOString(),
          text: `Manager Approval (Low/Negative Profit Override): ${submitManagerNote.trim()} (Projected Profit: $${projectedProfit.toFixed(2)})`,
          type: "Manager Approval",
          author
        };
        updates.items = submitPo.items.map((item, idx) => {
          if (idx === 0) {
            return {
              ...item,
              logs: [...(item.logs || []), approvalLog]
            };
          }
          return item;
        });
      }

      await updatePO(submitPo.id, updates);

      if (isLowProfit) {
        await logSecurityEvent({
          action: "ESTIMATE_LOW_PROFIT_APPROVED",
          category: "PROCUREMENT",
          userId: currentUser?.uid || "system",
          userEmail: currentUser?.email || "unknown",
          status: "SUCCESS",
          severity: "WARNING",
          details: {
            poId: submitPo.id,
            poNumber: submitPo.poNumber,
            clientName: submitPo.clientName,
            projectedProfit,
            managerNote: submitManagerNote.trim(),
            approvedRoles: currentUserRoles
          }
        });
      }
      
      // Update local state
      setPos(prev => prev.map(r => r.id === submitPo.id ? { ...r, ...updates } : r));
      // Update submitPo status locally to enable Export button
      setSubmitPo(prev => ({ ...prev, ...updates }));
      setIsSubmitted(true);
    } catch (err) {
      console.error("Error submitting PO to client:", err);
      setError("Failed to update status to Bid Submitted.");
    }
  };

  const syncPoNumberAcrossCollections = async (poId, oldPoNumber, newPoNumber, customerName) => {
    if (!oldPoNumber || oldPoNumber === newPoNumber) return;
    try {
      // 1. Sync Logistics shipments
      const logisticsCol = collection(db, "logistics");
      const logisticsQ = query(logisticsCol, where("poId", "==", poId));
      const logisticsSnapshot = await getDocs(logisticsQ);
      for (const shipDoc of logisticsSnapshot.docs) {
        await updateDoc(doc(db, "logistics", shipDoc.id), {
          poNumber: newPoNumber
        });
      }

      // 2. Sync Chat channels
      const chatsCol = collection(db, "chats");
      const chatsQ = query(chatsCol, where("poId", "==", poId));
      const chatsSnapshot = await getDocs(chatsQ);
      if (!chatsSnapshot.empty) {
        const clientName = customerName ? customerName.toLowerCase().replace(/[^a-z0-9]/g, "-") : "client";
        const newChannelName = `po-${newPoNumber.toLowerCase()}-${clientName}`;
        for (const chatDoc of chatsSnapshot.docs) {
          await updateDoc(doc(db, "chats", chatDoc.id), {
            name: newChannelName
          });
        }
      }

      // 3. Sync Inventory items
      const inventoryCol = collection(db, "inventory");
      const invQ = query(inventoryCol, where("poId", "==", poId));
      const invSnapshot = await getDocs(invQ);
      for (const invDoc of invSnapshot.docs) {
        await updateDoc(doc(db, "inventory", invDoc.id), {
          poNumber: newPoNumber
        });
      }
    } catch (err) {
      console.error("Failed to sync PO number across collections:", err);
    }
  };

  const handleUpdateBidConfirm = async (newPoNumber, reason) => {
    if (!updateBidPo) return;
    try {
      const oldPoNumber = updateBidPo.poNumber || "";
      const isReopening = updateBidPo.status !== "Bid Submitted";
      await updatePO(updateBidPo.id, {
        status: "Update Bid",
        updateBidReason: reason,
        poNumber: newPoNumber
      });

      await syncPoNumberAcrossCollections(
        updateBidPo.id, 
        oldPoNumber, 
        newPoNumber, 
        updateBidPo.customerName || updateBidPo.clientName
      );

      await logSecurityEvent({
        action: isReopening ? "ESTIMATE_REOPENED" : "ESTIMATE_UPDATE_BID",
        userId: currentUser?.uid || "system",
        userEmail: currentUser?.email || "unknown",
        details: {
          poId: updateBidPo.id,
          poNumber: newPoNumber,
          oldPoNumber,
          previousStatus: updateBidPo.status,
          newStatus: "Update Bid",
          reason
        }
      });

      setPos(prev => prev.map(p => p.id === updateBidPo.id ? { ...p, status: "Update Bid", updateBidReason: reason, poNumber: newPoNumber } : p));
      setUpdateBidPo(null);
    } catch (err) {
      console.error("Error updating bid:", err);
    }
  };

  async function handleOpenAddModal() {
    setError("");
    const savedDueDateDays = localStorage.getItem("global_po_due_date_days");
    const dueDays = savedDueDateDays !== null ? parseInt(savedDueDateDays, 10) : 3;
    
    const today = new Date();
    const y = today.getFullYear();
    const m = String(today.getMonth() + 1).padStart(2, "0");
    const d = String(today.getDate()).padStart(2, "0");
    const todayStr = `${y}-${m}-${d}`;

    const dueDateStr = addBusinessDays(todayStr, dueDays);

    let defaultLogoUrl = "";
    let defaultCompanyName = "";
    const activeLogo = (companyLogos || []).find(l => l.isActive);
    if (activeLogo) {
      defaultLogoUrl = activeLogo.url;
      defaultCompanyName = activeLogo.name || "";
    } else {
      const savedLogos = localStorage.getItem("global_company_logos");
      if (savedLogos) {
        try {
          const parsed = JSON.parse(savedLogos);
          const active = parsed.find(l => l.isActive);
          if (active) {
            defaultLogoUrl = active.url;
            defaultCompanyName = active.name || "";
          }
        } catch (e) {
          console.error("Failed to parse company logos:", e);
        }
      }
    }

    const companyKey = detectCompanyKey({
      logoUrl: defaultLogoUrl,
      companyName: defaultCompanyName,
      companyLogos
    });

    let nextPoNum = generateNextCompanyPoNumber({
      companyKey,
      existingPos: pos,
      companyLogos
    });

    try {
      const guaranteedNum = await getGuaranteedNextPoNumber({
        db,
        companyKey,
        companyLogos,
        existingPos: pos
      });
      if (guaranteedNum) nextPoNum = guaranteedNum;
    } catch (e) {
      console.warn("Could not query live Firestore for next sequence on open:", e);
    }

    setNewPoForm({
      poNumber: nextPoNum,
      customerPoNumber: "",
      clientName: "",
      companyName: defaultCompanyName,
      title: "",
      receivedFromCustomerDate: todayStr,
      date: todayStr,
      dueDate: dueDateStr,
      expirationDate: addCalendarDays(todayStr, 30),
      status: "Received",
      isPriority: false,
      items: [],
      shipToAddress: "",
      shipToAddress2: "",
      shipToCity: "",
      shipToState: "",
      shipToZip: "",
      markFor: "",
      paymentMethod: "",
      logoUrl: defaultLogoUrl
    });
    setEditingPoId(null);
    setModalOpen(true);
  }

  function handleOpenEditEstimateModal(po) {
    setError("");
    setEditingPoId(po.id);
    setNewPoForm({
      poNumber: po.poNumber || "",
      customerPoNumber: po.customerPoNumber || "",
      clientName: po.clientName || "",
      companyName: po.companyName || "",
      title: po.title || "",
      receivedFromCustomerDate: po.receivedFromCustomerDate || po.date || "",
      date: po.date || po.receivedFromCustomerDate || "",
      dueDate: po.dueDate || "",
      expirationDate: po.expirationDate || "",
      status: po.status || "Received",
      isPriority: !!po.isPriority,
      items: po.items || [],
      shipToAddress: po.shipToAddress || "",
      shipToAddress2: po.shipToAddress2 || "",
      shipToCity: po.shipToCity || "",
      shipToState: po.shipToState || "",
      shipToZip: po.shipToZip || "",
      markFor: po.markFor || "",
      paymentMethod: po.paymentMethod || "",
      logoUrl: po.logoUrl || "",
      additionalInfo: po.additionalInfo || "",
      estShippingCost: po.estShippingCost !== undefined ? po.estShippingCost : 0,
      markupRate: po.markupRate !== undefined ? po.markupRate : 15
    });
    setModalOpen(true);
  }

  async function handleCreatePO(e) {
    e.preventDefault();
    try {
      setError("");
      setActionLoading(true);
      const activeLogo = (companyLogos || []).find(l => l.url === newPoForm.logoUrl);
      const resolvedCompanyName = activeLogo?.name || newPoForm.companyName || "";

      let finalPoNumber = (newPoForm.poNumber || "").trim();
      if (!finalPoNumber) {
        setError("EST Number is required.");
        setActionLoading(false);
        return;
      }

      // Concurrency Collision Check: verify against live Firestore
      const isDuplicate = await checkPoNumberExists(db, finalPoNumber);
      if (isDuplicate) {
        const compKey = detectCompanyKey({
          logoUrl: newPoForm.logoUrl,
          companyName: resolvedCompanyName,
          companyLogos
        });
        
        const nextGuaranteedNum = await getGuaranteedNextPoNumber({
          db,
          companyKey: compKey,
          companyLogos,
          existingPos: pos
        });

        const isStandard = isStandardGeneratedPoNumber(finalPoNumber);
        if (isStandard) {
          console.warn(`Concurrent collision detected for ${finalPoNumber}. Automatically advanced to ${nextGuaranteedNum}.`);
          finalPoNumber = nextGuaranteedNum;
        } else {
          setError(`Estimate Number "${finalPoNumber}" already exists in the system. The next sequential available number is "${nextGuaranteedNum}".`);
          setActionLoading(false);
          return;
        }
      }

      const poPayload = {
        ...newPoForm,
        poNumber: finalPoNumber,
        companyName: resolvedCompanyName
      };
      const newPoId = await addPO(poPayload);
      const createdPo = { id: newPoId, ...poPayload };
      setPos(prev => {
        if (prev.some(p => p.id === newPoId || (p.poNumber && p.poNumber === poPayload.poNumber))) {
          return prev;
        }
        return [...prev, createdPo];
      });

      try {
        await logSecurityEvent({
          action: "ESTIMATE_CREATED",
          category: "DATA_MODIFICATION",
          userId: currentUser?.uid || "anonymous",
          userEmail: currentUser?.email || "anonymous",
          resource: `pos/${newPoId}`,
          status: "SUCCESS",
          details: {
            poNumber: finalPoNumber,
            clientName: poPayload.clientName,
            companyName: resolvedCompanyName
          }
        });
      } catch (logErr) {
        console.warn("Audit log notice:", logErr);
      }

      setModalOpen(false);
      setEditingPoId(null);
      
      // Auto-expand newly created PO
      setExpandedPoId(newPoId);
    } catch (err) {
      console.error("Error creating PO:", err);
      setError(err.message || "Failed to create PO. Please check database connection.");
    } finally {
      setActionLoading(false);
    }
  }

  async function handleUpdateExistingPO(e) {
    e.preventDefault();
    if (!editingPoId) return;
    try {
      setError("");
      setActionLoading(true);
      const targetPo = pos.find(p => p.id === editingPoId);
      if (!targetPo) return;

      const activeLogo = (companyLogos || []).find(l => l.url === newPoForm.logoUrl);
      const resolvedCompanyName = activeLogo?.name || newPoForm.companyName || targetPo.companyName || "";

      const updates = {
        companyName: resolvedCompanyName,
        logoUrl: newPoForm.logoUrl || "",
        poNumber: newPoForm.poNumber || targetPo.poNumber,
        customerPoNumber: newPoForm.customerPoNumber || "",
        clientName: newPoForm.clientName || targetPo.clientName,
        title: newPoForm.title || "",
        receivedFromCustomerDate: newPoForm.receivedFromCustomerDate || "",
        date: newPoForm.date || targetPo.date,
        dueDate: newPoForm.dueDate || "",
        expirationDate: newPoForm.expirationDate || "",
        isPriority: !!newPoForm.isPriority,
        shipToAddress: newPoForm.shipToAddress || "",
        shipToAddress2: newPoForm.shipToAddress2 || "",
        shipToCity: newPoForm.shipToCity || "",
        shipToState: newPoForm.shipToState || "",
        shipToZip: newPoForm.shipToZip || "",
        markFor: newPoForm.markFor || "",
        paymentMethod: newPoForm.paymentMethod || ""
      };

      // If PO number changed, sync across Logistics and Chats
      if (targetPo.poNumber && updates.poNumber && targetPo.poNumber !== updates.poNumber) {
        await syncPoNumberAcrossCollections(editingPoId, targetPo.poNumber, updates.poNumber, updates.clientName);
      }

      await updatePO(editingPoId, updates);

      // Update local state
      setPos(prev => prev.map(p => p.id === editingPoId ? { ...p, ...updates } : p));
      
      try {
        await logSecurityEvent({
          action: "ESTIMATE_UPDATED",
          category: "DATA_MODIFICATION",
          userId: currentUser?.uid || "anonymous",
          userEmail: currentUser?.email || "anonymous",
          resource: `pos/${editingPoId}`,
          status: "SUCCESS",
          details: {
            poNumber: updates.poNumber,
            clientName: updates.clientName,
            title: updates.title
          }
        });
      } catch (logErr) {
        console.error("Failed to log estimate update:", logErr);
      }

      setModalOpen(false);
      setEditingPoId(null);
    } catch (err) {
      console.error("Error updating estimate:", err);
      setError(err.message || "Failed to update estimate details.");
    } finally {
      setActionLoading(false);
    }
  }

  async function handleSavePOModal(e) {
    e.preventDefault();
    if (editingPoId) {
      await handleUpdateExistingPO(e);
    } else {
      await handleCreatePO(e);
    }
  }

  function handleOpenAddCustomerModal() {
    setError("");
    setCustomerForm({
      name: newPoForm.clientName || "",
      category: customerCategories[0] || "Enterprise",
      status: "Active",
      preferredPaymentMethod: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      billAddress: "",
      billAddress2: "",
      billCity: "",
      billState: "",
      billZip: "",
      shipAddress: "",
      shipAddress2: "",
      shipCity: "",
      shipState: "",
      shipZip: "",
      markFor: "",
      pocs: [{ name: "", title: "", email: "", phone: "" }]
    });
    setAddCustomerModalOpen(true);
  }

  async function handleCreateCustomer(e) {
    e.preventDefault();
    if (!customerForm.name.trim()) return;

    try {
      setError("");
      setActionLoading(true);
      await addCustomer(customerForm);
      
      // Auto fill PO creation modal fields with newly created customer details
      setNewPoForm(prev => ({
        ...prev,
        clientName: customerForm.name,
        shipToAddress: customerForm.shipAddress || customerForm.address || "",
        shipToAddress2: customerForm.shipAddress2 || customerForm.address2 || "",
        shipToCity: customerForm.shipCity || customerForm.city || "",
        shipToState: customerForm.shipState || customerForm.state || "",
        shipToZip: customerForm.shipZip || customerForm.zip || "",
        markFor: customerForm.markFor || "",
        paymentMethod: customerForm.preferredPaymentMethod || ""
      }));

      // Refresh customers list
      setAddCustomerModalOpen(false);
    } catch (err) {
      console.error("Error registering new customer from PO modal:", err);
      setError("Failed to register customer.");
    } finally {
      setActionLoading(false);
    }
  }

  function toggleRowExpand(poId) {
    setExpandedPoId(prev => (prev === poId ? null : poId));
  }

  // Get PO specific markup or fallback to global default
  const getPoMarkupRate = (po) => {
    if (po && po.markupRate !== undefined && po.markupRate !== null) {
      return parseFloat(po.markupRate);
    }
    const savedMarkup = localStorage.getItem("global_markup_rate");
    return savedMarkup !== null ? parseFloat(savedMarkup) : 15;
  };

  const getPoCcFee = () => {
    const savedFee = localStorage.getItem("global_cc_fee") || localStorage.getItem("global_non_cc_discount");
    return savedFee !== null ? parseFloat(savedFee) : 3;
  };

  const isCcPayment = (po) => {
    return Boolean(po && po.paymentMethod && po.paymentMethod.trim().toLowerCase() === "credit card");
  };

  const getEffectivePoMarkupRate = (po) => {
    const baseMarkup = getPoMarkupRate(po);
    if (isCcPayment(po)) {
      const ccFee = getPoCcFee();
      return baseMarkup + ccFee;
    }
    return baseMarkup;
  };

  const getItemMarkupRate = (item, po) => {
    if (item && item.isMarkupCustom && item.markupPercentage !== undefined && item.markupPercentage !== null) {
      return Number(item.markupPercentage);
    }
    return getEffectivePoMarkupRate(po);
  };

  const getItemMarkupDisplay = (item, po) => {
    if (item && item.isMarkupCustom) {
      if (item.markupType === "dollar" && item.markupDollar !== undefined && item.markupDollar !== null) {
        return `$${Number(item.markupDollar).toFixed(2)}`;
      }
      if (item.markupPercentage !== undefined && item.markupPercentage !== null) {
        return `${Number(item.markupPercentage)}%`;
      }
    }
    return `${getEffectivePoMarkupRate(po)}%`;
  };

  const getPoShippingCostOut = (po) => {
    if (!po) return 0;
    if (po.shippingCostOut !== undefined && po.shippingCostOut !== null && po.shippingCostOut !== "") {
      return Number(po.shippingCostOut);
    }
    if (po.estShippingCost !== undefined && po.estShippingCost !== null && po.estShippingCost !== "") {
      return Number(po.estShippingCost);
    }
    return 0;
  };

  // Calculate Proposed Client Charge (sum of line client prices with proportional shipping and outbound shipping)
  const calculateProposedClientCharge = (po) => {
    if (!po || !po.items) return 0;
    const multipliers = calculateVendorShippingMultipliers(po.items);
    const shippingOut = getPoShippingCostOut(po);
    const totalCost = calculateTotalCostSum(po.items, null, multipliers);
    const newDecimal = calculateNewDecimal(shippingOut, totalCost);
    const sum = po.items.reduce((acc, item) => {
      const markupRate = getItemMarkupRate(item, po);
      const price = (item.unitPrice !== undefined && item.unitPrice !== null && item.unitPrice !== "")
        ? Number(item.unitPrice)
        : recalculateItemClientPrice(item, markupRate, multipliers, null, newDecimal);
      return acc + (isNaN(price) ? 0 : price);
    }, 0);
    return Math.round(sum * 100) / 100;
  };

  const handleUpdatePoShippingOut = (poId, rawVal) => {
    setPos(prev => prev.map(p => {
      if (p.id !== poId) return p;
      const effectiveShippingOut = rawVal === "" ? 0 : Number(rawVal || 0);
      const updatedItems = recalculateAllPoItemClientPrices(
        p.items,
        item => getItemMarkupRate(item, p),
        getDefaultTaxRate(),
        effectiveShippingOut
      );
      return {
        ...p,
        shippingCostOut: rawVal,
        estShippingCost: effectiveShippingOut,
        items: updatedItems
      };
    }));
  };

  const handleSyncPoShippingOutToFirestore = async (poId) => {
    const po = pos.find(p => p.id === poId);
    if (!po) return;
    const effectiveShippingOut = Number(po.shippingCostOut !== undefined && po.shippingCostOut !== null && po.shippingCostOut !== "" ? po.shippingCostOut : (po.estShippingCost || 0));
    const updatedItems = recalculateAllPoItemClientPrices(
      po.items,
      item => getItemMarkupRate(item, po),
      getDefaultTaxRate(),
      effectiveShippingOut
    );
    try {
      await updatePO(poId, {
        shippingCostOut: effectiveShippingOut,
        estShippingCost: effectiveShippingOut,
        items: updatedItems,
        status: po.status
      });
      await logSecurityEvent({
        action: "ESTIMATE_SHIPPING_OUT_UPDATED",
        category: "FINANCIAL",
        severity: "LOW",
        details: {
          poId,
          poNumber: po.poNumber,
          shippingCostOut: effectiveShippingOut
        }
      });
    } catch (err) {
      console.error("Error saving Shipping Cost Out:", err);
    }
  };

  const handleOpenShippingCostOutModal = (po) => {
    setSelectedShippingPo(po);
    const currentVal = getPoShippingCostOut(po);
    setTempShippingCostOut(currentVal > 0 ? currentVal.toString() : "");
    setShippingCostOutError("");
    setShippingCostOutModalOpen(true);
  };

  const handleSaveShippingCostOutModal = async (e) => {
    e.preventDefault();
    if (!selectedShippingPo) return;
    const parsedVal = tempShippingCostOut === "" ? 0 : parseFloat(tempShippingCostOut);
    if (isNaN(parsedVal) || parsedVal < 0) {
      setShippingCostOutError("Please enter a valid non-negative shipping amount.");
      return;
    }
    setShippingCostOutSubmitting(true);
    setShippingCostOutError("");
    try {
      const effectiveShippingOut = parsedVal;
      const updatedItems = recalculateAllPoItemClientPrices(
        selectedShippingPo.items,
        item => getItemMarkupRate(item, selectedShippingPo),
        getDefaultTaxRate(),
        effectiveShippingOut
      );

      setPos(prev => prev.map(p => {
        if (p.id !== selectedShippingPo.id) return p;
        return {
          ...p,
          shippingCostOut: effectiveShippingOut,
          estShippingCost: effectiveShippingOut,
          items: updatedItems
        };
      }));

      await updatePO(selectedShippingPo.id, {
        shippingCostOut: effectiveShippingOut,
        estShippingCost: effectiveShippingOut,
        items: updatedItems,
        status: selectedShippingPo.status
      });

      await logSecurityEvent({
        action: "ESTIMATE_SHIPPING_OUT_UPDATED",
        category: "Procurement",
        severity: "LOW",
        details: {
          poId: selectedShippingPo.id,
          poNumber: selectedShippingPo.poNumber,
          previousAmount: getPoShippingCostOut(selectedShippingPo),
          newAmount: effectiveShippingOut,
          userId: currentUser?.uid || "unknown",
          userEmail: currentUser?.email || "unknown"
        }
      });

      setShippingCostOutModalOpen(false);
      setSelectedShippingPo(null);
    } catch (err) {
      console.error("Error saving Shipping Cost Out:", err);
      setShippingCostOutError("Failed to save shipping cost out. Please try again.");
    } finally {
      setShippingCostOutSubmitting(false);
    }
  };

  const getNextLineNumber = (items) => {
    if (!items || items.length === 0) return "01";
    const lastItem = items[items.length - 1];
    const lastNumStr = lastItem.lineNumber;
    if (!lastNumStr) {
      const next = items.length + 1;
      return next < 10 ? `0${next}` : String(next);
    }
    const lastNum = parseInt(lastNumStr, 10);
    if (isNaN(lastNum)) {
      const next = items.length + 1;
      return next < 10 ? `0${next}` : String(next);
    }
    const nextNum = lastNum + 1;
    return nextNum < 10 ? `0${nextNum}` : String(nextNum);
  };

  const syncItemToLogisticsShipment = async (poId, itemId, action) => {
    try {
      const logisticsCol = collection(db, "logistics");
      const q = query(logisticsCol, where("poId", "==", poId));
      const qSnapshot = await getDocs(q);
      if (!qSnapshot.empty) {
        const shipmentDoc = qSnapshot.docs[0];
        const shipmentData = shipmentDoc.data();
        const updatedItemStatuses = { ...(shipmentData.itemStatuses || {}) };
        
        if (action === "add") {
          updatedItemStatuses[itemId] = {
            status: "To Order",
            orderedDate: ""
          };
        } else if (action === "delete") {
          delete updatedItemStatuses[itemId];
        }
        
        await updateDoc(doc(db, "logistics", shipmentDoc.id), {
          itemStatuses: updatedItemStatuses
        });
      }
    } catch (err) {
      console.error("Failed to sync item change to logistics shipment:", err);
    }
  };

  const findExistingVendorTax = (targetVendorName, po, allPos = []) => {
    if (!targetVendorName || !targetVendorName.trim()) return null;
    const vendorNorm = targetVendorName.trim().toLowerCase();
    
    // 1. Check inside current PO items first
    if (po && po.items) {
      for (const it of po.items) {
        const vList = it.vendors && it.vendors.length > 0 ? it.vendors : [{ vendor: it.vendor, tax: it.tax }];
        for (const spl of vList) {
          if (spl.vendor && spl.vendor.trim().toLowerCase() === vendorNorm) {
            if (spl.tax !== undefined && spl.tax !== null && String(spl.tax).trim() !== "" && String(spl.tax).trim() !== "0.00" && String(spl.tax).trim() !== "0") {
              return spl.tax;
            }
          }
        }
      }
    }

    // 2. Check across other loaded POs in state if not found in current PO
    if (allPos && allPos.length > 0) {
      for (const otherPo of allPos) {
        if (!otherPo.items) continue;
        for (const it of otherPo.items) {
          const vList = it.vendors && it.vendors.length > 0 ? it.vendors : [{ vendor: it.vendor, tax: it.tax }];
          for (const spl of vList) {
            if (spl.vendor && spl.vendor.trim().toLowerCase() === vendorNorm) {
              if (spl.tax !== undefined && spl.tax !== null && String(spl.tax).trim() !== "" && String(spl.tax).trim() !== "0.00" && String(spl.tax).trim() !== "0") {
                return spl.tax;
              }
            }
          }
        }
      }
    }

    return null;
  };

  // Add line item directly to the table (Spreadsheet style)
  async function handleAddNewLineItemDirect(po) {
    try {
      const nextLineNum = getNextLineNumber(po.items);

      const newItem = {
        id: `li-${Date.now()}`,
        lineNumber: nextLineNum,
        description: "",
        quantity: 1,
        unitPrice: 0,
        vendor: "",
        vendorPrice: "0.00",
        isTaxable: true,
        tax: true,
        shippingCost: "0.00",
        staff: currentUser?.email?.split("@")[0] || "",
        url: ""
      };

      const newItemsList = [...(po.items || []), newItem];
      const updatedItems = recalculateAllPoItemClientPrices(newItemsList, item => getItemMarkupRate(item, po), getDefaultTaxRate(), getPoShippingCostOut(po));

      let newStatus = po.status;
      if (po.status === "Received") {
        newStatus = "Draft Bid";
      }

      // Update local state first for immediate UI feedback
      const updatedPo = { ...po, items: updatedItems, status: newStatus };
      setPos(prev => prev.map(r => r.id === po.id ? updatedPo : r));

      // Sync to Firestore
      await updatePO(po.id, { items: updatedItems, status: newStatus });

      if (po.status === "Won") {
        await syncItemToLogisticsShipment(po.id, newItem.id, "add");
      }
    } catch (err) {
      console.error("Error adding direct line item:", err);
    }
  }

  // Insert line item directly between rows (Spreadsheet style)
  async function handleInsertLineItemDirect(po, targetIndex, position = "below") {
    try {
      const insertIdx = position === "above" ? Math.max(0, targetIndex) : targetIndex + 1;

      const currentItems = po.items || [];
      const refItem = currentItems[targetIndex];
      const refNum = refItem?.lineNumber ? String(refItem.lineNumber).trim() : "";

      let defaultLineNum = "";
      if (refNum) {
        if (position === "below") {
          // If inserting below e.g. "01", assign a non-colliding sub-line number like "01.1", "01.2"
          const baseNum = refNum.split(".")[0];
          let subIdx = 1;
          while (currentItems.some(it => String(it.lineNumber || "").trim() === `${baseNum}.${subIdx}`)) {
            subIdx++;
          }
          defaultLineNum = `${baseNum}.${subIdx}`;
        } else {
          // If inserting above, leave blank for manual input or sub-index
          defaultLineNum = "";
        }
      }

      const newItem = {
        id: `li-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
        lineNumber: defaultLineNum,
        description: "",
        quantity: 1,
        unitPrice: 0,
        vendor: "",
        vendorPrice: "0.00",
        isTaxable: true,
        tax: true,
        shippingCost: "0.00",
        staff: currentUser?.email?.split("@")[0] || "",
        url: ""
      };

      const spliced = [
        ...currentItems.slice(0, insertIdx),
        newItem,
        ...currentItems.slice(insertIdx)
      ];

      // Preserve existing line numbers without re-sequencing other items
      const updatedItems = recalculateAllPoItemClientPrices(spliced, item => getItemMarkupRate(item, po), getDefaultTaxRate(), getPoShippingCostOut(po));

      let newStatus = po.status;
      if (po.status === "Received") {
        newStatus = "Draft Bid";
      }

      // Update local state first for immediate UI feedback
      const updatedPo = { ...po, items: updatedItems, status: newStatus };
      setPos(prev => prev.map(r => r.id === po.id ? updatedPo : r));

      // Sync to Firestore
      await updatePO(po.id, { items: updatedItems, status: newStatus });

      if (po.status === "Won") {
        await syncItemToLogisticsShipment(po.id, newItem.id, "add");
      }
    } catch (err) {
      console.error("Error inserting direct line item:", err);
    }
  }

  // Update item field locally (onChange)
  function handleUpdateItemFieldLocal(poId, itemId, field, value) {
    setPos(prev => prev.map(po => {
      if (po.id !== poId) return po;
      
      const rawUpdatedItems = (po.items || []).map(item => {
        if (item.id !== itemId) return item;
        
        let parsedValue = value;
        if (field === "quantity") {
          parsedValue = value === "" ? "" : Number(value);
        } else if (field === "unitPrice" || field === "vendorPrice" || field === "tax" || field === "shippingCost") {
          parsedValue = value;
        }
        
        return { ...item, [field]: parsedValue };
      });

      let updatedItems = rawUpdatedItems;
      if (field === "quantity" || field === "vendorPrice" || field === "shippingCost" || field === "vendor" || field === "tax") {
        updatedItems = recalculateAllPoItemClientPrices(rawUpdatedItems, item => getItemMarkupRate(item, po), getDefaultTaxRate(), getPoShippingCostOut(po));
      }

      // If status is "Received", shift to "Draft Bid" since changes are being made
      let newStatus = po.status;
      if (po.status === "Received") {
        newStatus = "Draft Bid";
      }

      return { ...po, items: updatedItems, status: newStatus };
    }));
  }

  // Handle vendor split helpers
  async function handleAddVendorSplit(poId, itemId) {
    const po = pos.find(p => p.id === poId);
    if (!po) return;
    
    let newStatus = po.status;
    if (po.status === "Received") {
      newStatus = "Draft Bid";
    }
    
    const rawUpdatedItems = (po.items || []).map(item => {
      if (item.id !== itemId) return item;
      
      const existingVendors = item.vendors && item.vendors.length > 0 ? item.vendors : [
        { id: 'default', vendor: item.vendor || "", quantity: item.quantity || 1, vendorPrice: item.vendorPrice || 0, tax: item.tax || "0.00", shippingCost: item.shippingCost || 0, url: item.url || "" }
      ];
      
      const newVendor = {
        id: `v-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
        vendor: "",
        quantity: 1,
        vendorPrice: 0,
        isTaxable: true,
        tax: true,
        shippingCost: 0,
        url: ""
      };
      
      const updatedItem = {
        ...item,
        vendors: [...existingVendors, newVendor],
        vendor: "",
        vendorPrice: 0,
        isTaxable: true,
        tax: true,
        shippingCost: 0,
        url: ""
      };
      updatedItem.quantity = updatedItem.vendors.reduce((sum, v) => sum + Number(v.quantity || 0), 0);
      return updatedItem;
    });

    const updatedItems = recalculateAllPoItemClientPrices(rawUpdatedItems, item => getItemMarkupRate(item, po), getDefaultTaxRate(), getPoShippingCostOut(po));

    setPos(prev => prev.map(p => p.id === poId ? { ...p, items: updatedItems, status: newStatus } : p));
    try {
      await updatePO(poId, { items: updatedItems, status: newStatus });
    } catch (err) {
      console.error("Error adding vendor split:", err);
    }
  }

  async function handleRemoveVendorSplit(poId, itemId, vendorId) {
    const po = pos.find(p => p.id === poId);
    if (!po) return;
    
    let newStatus = po.status;
    if (po.status === "Received") {
      newStatus = "Draft Bid";
    }
    
    const rawUpdatedItems = (po.items || []).map(item => {
      if (item.id !== itemId) return item;
      
      const existingVendors = item.vendors && item.vendors.length > 0 ? item.vendors : [
        { id: 'default', vendor: item.vendor || "", quantity: item.quantity || 1, vendorPrice: item.vendorPrice || 0, tax: item.tax || "0.00", shippingCost: item.shippingCost || 0, url: item.url || "" }
      ];
      
      const updatedVendors = existingVendors.filter(v => v.id !== vendorId);
      
      const updatedItem = {
        ...item,
        vendors: updatedVendors
      };
      updatedItem.quantity = updatedVendors.reduce((sum, v) => sum + Number(v.quantity || 0), 0);
      return updatedItem;
    });

    const updatedItems = recalculateAllPoItemClientPrices(rawUpdatedItems, item => getItemMarkupRate(item, po), getDefaultTaxRate(), getPoShippingCostOut(po));

    setPos(prev => prev.map(p => p.id === poId ? { ...p, items: updatedItems, status: newStatus } : p));
    try {
      await updatePO(poId, { items: updatedItems, status: newStatus });
    } catch (err) {
      console.error("Error removing vendor split:", err);
    }
  }

  function handleUpdateVendorFieldLocal(poId, itemId, vendorId, field, value) {
    setPos(prev => prev.map(po => {
      if (po.id !== poId) return po;
      const rawUpdatedItems = (po.items || []).map(item => {
        if (item.id !== itemId) return item;
        
        const existingVendors = item.vendors && item.vendors.length > 0 ? item.vendors : [
          { id: 'default', vendor: item.vendor || "", quantity: item.quantity || 1, vendorPrice: item.vendorPrice || 0, tax: item.tax || "0.00", shippingCost: item.shippingCost || 0, url: item.url || "" }
        ];
        
        const updatedVendors = existingVendors.map(v => {
          if (v.id !== vendorId && !(vendorId === 'default' && (!v.id || v.id === 'default'))) return v;
          
          let parsedValue = value;
          if (field === "quantity") {
             parsedValue = value === "" ? "" : Number(value);
          }
          
          let updatedSplit = { ...v, [field]: parsedValue };
          
          // Auto-update tax checkbox based on vendor tax exemption status
          if (field === "vendor" && value && value.trim()) {
            const normVal = value.trim().toLowerCase();
            const matchedVendor = (vendors || []).find(vend => (vend.name || "").trim().toLowerCase() === normVal);
            if (matchedVendor) {
              const isExempt = String(matchedVendor.taxExempt).toLowerCase() === "yes" || matchedVendor.taxExempt === true;
              if (isExempt) {
                updatedSplit.isTaxable = false;
                updatedSplit.tax = 0;
              } else {
                updatedSplit.isTaxable = true;
                updatedSplit.tax = getDefaultTaxRate();
              }
            } else {
              const autofilledTax = findExistingVendorTax(value, po, prev);
              if (autofilledTax !== null && (!v.tax || v.tax === "0.00" || v.tax === "0" || v.tax === 0)) {
                updatedSplit.tax = autofilledTax;
              }
            }
          }
          
          return updatedSplit;
        });
        
        const topVendor = updatedVendors.length === 1 ? updatedVendors[0].vendor : item.vendor;
        const topTax = updatedVendors.length === 1 ? updatedVendors[0].tax : item.tax;
        const topIsTaxable = updatedVendors.length === 1 ? updatedVendors[0].isTaxable : item.isTaxable;
        const topUrl = updatedVendors.length === 1 ? updatedVendors[0].url : item.url;

        const updatedItem = {
          ...item,
          vendor: topVendor,
          tax: topTax,
          isTaxable: topIsTaxable !== undefined ? topIsTaxable : item.isTaxable,
          url: topUrl,
          vendors: updatedVendors
        };
        updatedItem.quantity = updatedVendors.reduce((sum, v) => sum + Number(v.quantity || 0), 0);
        return updatedItem;
      });
      
      const updatedItems = recalculateAllPoItemClientPrices(rawUpdatedItems, item => getItemMarkupRate(item, po), getDefaultTaxRate(), getPoShippingCostOut(po));
      
      let newStatus = po.status;
      if (po.status === "Received") {
        newStatus = "Draft Bid";
      }
      return { ...po, items: updatedItems, status: newStatus };
    }));
  }

  // Atomic async updater that immediately reflects in local state and persists to Firestore
  async function handleUpdateVendorFieldAndSync(poId, itemId, vendorId, field, value) {
    const po = pos.find(p => p.id === poId);
    if (!po) return;
    
    let newStatus = po.status;
    if (po.status === "Received") {
      newStatus = "Draft Bid";
    }

    const rawUpdatedItems = (po.items || []).map(item => {
      if (item.id !== itemId) return item;
      
      const existingVendors = item.vendors && item.vendors.length > 0 ? item.vendors : [
        { id: 'default', vendor: item.vendor || "", quantity: item.quantity || 1, vendorPrice: item.vendorPrice || 0, tax: item.tax || "0.00", shippingCost: item.shippingCost || 0, url: item.url || "" }
      ];
      
      const updatedVendors = existingVendors.map(v => {
        if (v.id !== vendorId && !(vendorId === 'default' && (!v.id || v.id === 'default'))) return v;
        
        let parsedValue = value;
        if (field === "quantity") {
          parsedValue = value === "" ? "" : Number(value);
        }
        
        let updatedSplit = { ...v, [field]: parsedValue };
        
        // Auto-update tax checkbox based on vendor tax exemption status
        if (field === "vendor" && value && value.trim()) {
          const normVal = value.trim().toLowerCase();
          const matchedVendor = (vendors || []).find(vend => (vend.name || "").trim().toLowerCase() === normVal);
          if (matchedVendor) {
            const isExempt = String(matchedVendor.taxExempt).toLowerCase() === "yes" || matchedVendor.taxExempt === true;
            if (isExempt) {
              updatedSplit.isTaxable = false;
              updatedSplit.tax = 0;
            } else {
              updatedSplit.isTaxable = true;
              updatedSplit.tax = getDefaultTaxRate();
            }
          } else {
            const autofilledTax = findExistingVendorTax(value, po, pos);
            if (autofilledTax !== null && (!v.tax || v.tax === "0.00" || v.tax === "0" || v.tax === 0)) {
              updatedSplit.tax = autofilledTax;
            }
          }
        }
        
        return updatedSplit;
      });
      
      const topVendor = updatedVendors.length === 1 ? updatedVendors[0].vendor : item.vendor;
      const topTax = updatedVendors.length === 1 ? updatedVendors[0].tax : item.tax;
      const topIsTaxable = updatedVendors.length === 1 ? updatedVendors[0].isTaxable : item.isTaxable;
      const topUrl = updatedVendors.length === 1 ? updatedVendors[0].url : item.url;

      const updatedItem = {
        ...item,
        vendor: topVendor,
        tax: topTax,
        isTaxable: topIsTaxable !== undefined ? topIsTaxable : item.isTaxable,
        url: topUrl,
        vendors: updatedVendors
      };
      updatedItem.quantity = updatedVendors.reduce((sum, v) => sum + Number(v.quantity || 0), 0);
      return updatedItem;
    });

    const updatedItems = recalculateAllPoItemClientPrices(rawUpdatedItems, item => getItemMarkupRate(item, po), getDefaultTaxRate(), getPoShippingCostOut(po));

    // 1. Update state immediately
    setPos(prev => prev.map(p => p.id === poId ? { ...p, items: updatedItems, status: newStatus } : p));

    // 2. Persist directly to Firestore
    try {
      await updatePO(poId, { items: updatedItems, status: newStatus });
    } catch (err) {
      console.error("Failed to update and sync vendor field:", err);
    }
  }

  // Toggle tax checkbox for a line item or vendor split
  async function handleToggleItemTax(poId, itemId, vendorId, checked) {
    const po = pos.find(p => p.id === poId);
    if (!po) return;

    let newStatus = po.status;
    if (po.status === "Received") {
      newStatus = "Draft Bid";
    }

    const defaultTaxRate = getDefaultTaxRate();

    const rawUpdatedItems = (po.items || []).map(item => {
      if (item.id !== itemId) return item;

      const existingVendors = item.vendors && item.vendors.length > 0 ? item.vendors : [
        { id: 'default', vendor: item.vendor || "", quantity: item.quantity || 1, vendorPrice: item.vendorPrice || 0, isTaxable: item.isTaxable !== false, tax: item.tax, shippingCost: item.shippingCost || 0, url: item.url || "" }
      ];

      const updatedVendors = existingVendors.map(v => {
        if (v.id !== vendorId && !(vendorId === 'default' && (!v.id || v.id === 'default'))) return v;
        return {
          ...v,
          isTaxable: checked,
          tax: checked ? defaultTaxRate : 0
        };
      });

      const topIsTaxable = updatedVendors.length === 1 ? updatedVendors[0].isTaxable : item.isTaxable;
      const topTax = updatedVendors.length === 1 ? updatedVendors[0].tax : (checked ? defaultTaxRate : 0);

      const updatedItem = {
        ...item,
        isTaxable: topIsTaxable !== undefined ? topIsTaxable : checked,
        tax: topTax,
        vendors: updatedVendors
      };
      return updatedItem;
    });

    const updatedItems = recalculateAllPoItemClientPrices(rawUpdatedItems, item => getItemMarkupRate(item, po), defaultTaxRate, getPoShippingCostOut(po));

    setPos(prev => prev.map(p => p.id === poId ? { ...p, items: updatedItems, status: newStatus } : p));

    try {
      await updatePO(poId, { items: updatedItems, status: newStatus });
    } catch (err) {
      console.error("Error toggling item tax:", err);
    }
  }

  // Sync line items to Firestore (onBlur)
  async function handleSyncItemsToFirestore(poId) {
    const po = pos.find(r => r.id === poId);
    if (!po) return;

    try {
      const rawCleanedItems = po.items.map(item => {
        const qty = item.quantity === "" ? 0 : Number(item.quantity || 0);
        const vPrice = item.vendorPrice === "" || isNaN(Number(item.vendorPrice)) ? "0.00" : Number(item.vendorPrice).toFixed(2);
        const sCost = item.shippingCost === "" || isNaN(Number(item.shippingCost)) ? "0.00" : Number(item.shippingCost).toFixed(2);
        const taxVal = item.tax === "" || isNaN(Number(item.tax)) ? (item.tax !== undefined ? item.tax : "0.00") : Number(item.tax).toFixed(2);
        
        const cleanedVendors = (item.vendors || []).map(v => ({
          ...v,
          quantity: v.quantity === "" ? 0 : Number(v.quantity || 0),
          vendorPrice: v.vendorPrice === "" || isNaN(Number(v.vendorPrice)) ? "0.00" : Number(v.vendorPrice).toFixed(2),
          tax: v.tax === "" || isNaN(Number(v.tax)) ? (v.tax !== undefined ? v.tax : "0.00") : Number(v.tax).toFixed(2),
          shippingCost: v.shippingCost === "" || isNaN(Number(v.shippingCost)) ? "0.00" : Number(v.shippingCost).toFixed(2)
        }));

        return {
          ...item,
          quantity: qty,
          vendorPrice: vPrice,
          tax: taxVal,
          shippingCost: sCost,
          ...(cleanedVendors.length > 0 ? { vendors: cleanedVendors } : {})
        };
      });

      const cleanedItems = recalculateAllPoItemClientPrices(rawCleanedItems, item => getItemMarkupRate(item, po), getDefaultTaxRate(), getPoShippingCostOut(po));

      // Update local state first so UI shows the formatted ".00" values
      setPos(prev => prev.map(r => r.id === poId ? { ...r, items: cleanedItems } : r));

      await updatePO(poId, { items: cleanedItems, status: po.status });
    } catch (err) {
      console.error("Error syncing items to Firestore:", err);
    }
  }

  const handleSelectVendorFromTagSearch = async (vendorName) => {
    if (tagSearchTarget) {
      const target = tagSearchTarget;
      setTagSearchTarget(null);
      await handleUpdateVendorFieldAndSync(target.poId, target.itemId, target.vendorId, "vendor", vendorName);
    }
  };

  // Delete line item
  async function handleDeleteLineItem(po, itemId) {
    try {
      const remainingItems = po.items.filter(item => item.id !== itemId);
      const updatedItems = recalculateAllPoItemClientPrices(remainingItems, item => getItemMarkupRate(item, po), getDefaultTaxRate(), getPoShippingCostOut(po));
      
      const updatedPo = { ...po, items: updatedItems };
      setPos(prev => prev.map(r => r.id === po.id ? updatedPo : r));

      await updatePO(po.id, { items: updatedItems });

      if (po.status === "Won") {
        await syncItemToLogisticsShipment(po.id, itemId, "delete");
      }
    } catch (err) {
      console.error("Error deleting line item:", err);
    }
  }

  // Update PO status
  async function handleUpdateStatus(po, newStatus) {
    try {
      const updates = { status: newStatus };
      if (newStatus === "Bid Submitted" && !po.submittedDate) {
        updates.submittedDate = new Date().toISOString().split("T")[0];
      }
      await updatePO(po.id, updates);

      const updatedPo = { ...po, ...updates };
      setPos(prev => prev.map(r => r.id === po.id ? updatedPo : r));
    } catch (err) {
      console.error("Error updating PO status:", err);
    }
  }

  const handleOpenPoStatusChange = (po, newStatus) => {
    const completedStatuses = ["Won", "Lost", "Proposal Lost", "Cancelled", "On Hold", "Not Granted"];
    if (completedStatuses.includes(newStatus)) {
      setStatusUpdatePo(po);
      setStatusUpdateNewStatus(newStatus);
      setAwardedDate(new Date().toISOString().split("T")[0]);
      setStatusCustomerPo(po.customerPoNumber || "");
      setStatusUpdateModalOpen(true);
    } else {
      const totalMaterialCost = calculateTotalCostSum(po.items);
      const totalEstimateAmount = calculateProposedClientCharge(po);
      const projectedProfit = totalEstimateAmount - totalMaterialCost;
      const isLowProfit = projectedProfit <= 0.0001;

      if (isLowProfit) {
        handleOpenSubmitModal(po);
      } else {
        handleUpdateStatus(po, "Bid Submitted");
      }
    }
  };

  const handleMoveToLogistics = async (po, dateAwarded) => {
    try {
      const trackNum = `TRK-${Math.floor(100000 + Math.random() * 900000)}`;
      
      let destination = "Client Facility";
      if (po.shipToAddress) {
        const parts = [
          po.shipToAddress,
          po.shipToAddress2,
          po.shipToCity,
          po.shipToState,
          po.shipToZip
        ].filter(Boolean);
        destination = parts.join(", ");
      } else if (po.clientName) {
        destination = po.clientName;
      }

      const vendorsList = po.items ? [...new Set(po.items.map(item => item.vendor).filter(Boolean))] : [];
      const origin = vendorsList.length > 0 ? vendorsList.join(", ") : "Vendor Warehouse";

      const baseDate = dateAwarded ? new Date(dateAwarded) : new Date();
      const estimatedDelivery = new Date(baseDate.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];

      const logisticsItem = {
        trackingNumber: trackNum,
        carrier: "Pending Carrier",
        origin: origin,
        destination: destination,
        estimatedDelivery: estimatedDelivery,
        status: "To Order",
        poId: po.id,
        poNumber: po.poNumber,
        customerPoNumber: po.customerPoNumber || "",
        clientName: po.clientName,
        awardedDate: dateAwarded
      };

      await addShipment(logisticsItem);
    } catch (err) {
      console.error("Error moving PO to logistics:", err);
    }
  };

  const handleSaveStatusUpdate = async () => {
    if (!statusUpdatePo) return;
    try {
      const updates = { status: statusUpdateNewStatus };
      if (statusUpdateNewStatus === "Won") {
        updates.awardedDate = awardedDate;
        updates.customerPoNumber = (statusCustomerPo || "").trim();
      } else {
        updates.awardedDate = "";
      }
      
      await updatePO(statusUpdatePo.id, updates);
      
      setPos(prev => prev.map(r => r.id === statusUpdatePo.id ? { ...r, ...updates } : r));
      
      if (statusUpdateNewStatus === "Won") {
        await handleMoveToLogistics({ ...statusUpdatePo, ...updates }, awardedDate);
      }

      await logSecurityEvent({
        action: "ESTIMATE_STATUS_UPDATED",
        userId: currentUser?.uid || "system",
        userEmail: currentUser?.email || "unknown",
        details: {
          poId: statusUpdatePo.id,
          poNumber: statusUpdatePo.poNumber,
          previousStatus: statusUpdatePo.status,
          newStatus: statusUpdateNewStatus,
          awardedDate: statusUpdateNewStatus === "Won" ? awardedDate : undefined,
          customerPoNumber: statusUpdateNewStatus === "Won" ? (statusCustomerPo || "").trim() : undefined
        }
      });
      
      setStatusUpdateModalOpen(false);
      setStatusUpdatePo(null);
    } catch (err) {
      console.error("Error saving PO status update:", err);
      setError("Failed to update PO status.");
    }
  };

  const handleOpenMarkupModal = (po) => {
    setMarkupPo(po);
    setTempMarkupRate(getPoMarkupRate(po));
    setMarkupModalOpen(false);
    setError("");
    setMarkupModalOpen(true);
  };

  const handleSavePoMarkup = async (e) => {
    e.preventDefault();
    if (!markupPo) return;

    try {
      setError("");
      const newRate = Number(tempMarkupRate);
      const poWithNewRate = { ...markupPo, markupRate: newRate };
      const updatedItems = recalculateAllPoItemClientPrices(markupPo.items, item => getItemMarkupRate(item, poWithNewRate), getDefaultTaxRate(), getPoShippingCostOut(markupPo));

      setPos(prev => prev.map(r => r.id === markupPo.id ? { ...r, markupRate: newRate, items: updatedItems } : r));
      
      await updatePO(markupPo.id, { 
        markupRate: newRate,
        items: updatedItems
      });
      
      setMarkupModalOpen(false);
    } catch (err) {
      console.error("Error updating PO markup rate:", err);
      setError("Failed to update markup rate.");
    }
  };

  const handleSaveLineMarkup = async (markupConfig) => {
    if (!selectedMarkupPo || !selectedMarkupItem) return;
    try {
      const rawUpdatedItems = selectedMarkupPo.items.map(item => {
        if (item.id !== selectedMarkupItem.id) return item;
        
        let updatedItem;
        if (!markupConfig) {
          // Reset to default
          updatedItem = {
            ...item,
            markupType: null,
            markupPercentage: null,
            markupDollar: null,
            isMarkupCustom: false
          };
        } else if (markupConfig.type === "dollar") {
          updatedItem = {
            ...item,
            markupType: "dollar",
            markupDollar: markupConfig.value,
            markupPercentage: null,
            isMarkupCustom: true
          };
        } else {
          updatedItem = {
            ...item,
            markupType: "percent",
            markupPercentage: markupConfig.value,
            markupDollar: null,
            isMarkupCustom: true
          };
        }
        return updatedItem;
      });

      const updatedItems = recalculateAllPoItemClientPrices(rawUpdatedItems, item => getItemMarkupRate(item, selectedMarkupPo), getDefaultTaxRate(), getPoShippingCostOut(selectedMarkupPo));

      setPos(prev => prev.map(p => p.id === selectedMarkupPo.id ? { ...p, items: updatedItems } : p));
      await updatePO(selectedMarkupPo.id, { items: updatedItems });
      
      setCustomMarkupModalOpen(false);
      setSelectedMarkupItem(null);
      setSelectedMarkupPo(null);
    } catch (err) {
      console.error("Error saving line markup override:", err);
    }
  };

  const handleSaveAdditionalInfo = async (e) => {
    e.preventDefault();
    if (!additionalInfoPo) return;
    try {
      await updatePO(additionalInfoPo.id, {
        additionalInfo: tempAdditionalInfo
      });
      setAdditionalInfoModalOpen(false);
      setAdditionalInfoPo(null);
    } catch (err) {
      console.error("Error updating additional info:", err);
      setError("Failed to update additional info.");
    }
  };

  const handleGeneratePDF = (po) => {
    let activeLogoUrl = po.logoUrl || "";
    if (!activeLogoUrl) {
      const savedLogos = localStorage.getItem("global_company_logos");
      if (savedLogos) {
        try {
          const parsed = JSON.parse(savedLogos);
          const active = parsed.find(l => l.isActive);
          if (active) activeLogoUrl = active.url;
        } catch (e) {
          console.error("Failed to parse logos for PDF:", e);
        }
      }
    }
    
    const markupPct = getEffectivePoMarkupRate(po);
    const multipliers = calculateVendorShippingMultipliers(po.items);
    const shippingOut = getPoShippingCostOut(po);
    const totalCost = calculateTotalCostSum(po.items, null, multipliers);
    const newDecimal = calculateNewDecimal(shippingOut, totalCost);
    const clientPriceSum = po.items ? po.items.reduce((sum, item) => {
      const lineClientTotal = Number((item.unitPrice !== undefined && item.unitPrice !== null && item.unitPrice !== "")
        ? item.unitPrice
        : recalculateItemClientPrice(item, getItemMarkupRate(item, po), multipliers, null, newDecimal)
      );
      return sum + (isNaN(lineClientTotal) ? 0 : lineClientTotal);
    }, 0) : 0;

    const styles = `
      body {
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        color: #2c3e50;
        margin: 0;
        padding: 0;
        line-height: 1.5;
        background-color: #f8fafc;
      }
      .content-wrapper {
        background-color: #ffffff;
        max-width: 900px;
        margin: 30px auto;
        padding: 40px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
      }
      .header-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 40px;
      }
      .header-table td {
        border: none;
        padding: 0;
        vertical-align: top;
      }
      .title {
        font-size: 26px;
        font-weight: 800;
        color: #2980b9;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        margin-bottom: 10px;
      }
      .meta-info {
        font-size: 14px;
        color: #7f8c8d;
      }
      .meta-info strong {
        color: #2c3e50;
      }
      .client-info {
        text-align: right;
      }
      .client-label {
        font-size: 11px;
        text-transform: uppercase;
        color: #95a5a6;
        font-weight: 700;
        letter-spacing: 1px;
      }
      .client-name {
        font-size: 20px;
        font-weight: 700;
        color: #2c3e50;
        margin-top: 5px;
      }
      .section-title {
        font-size: 12px;
        text-transform: uppercase;
        color: #95a5a6;
        font-weight: 700;
        letter-spacing: 1px;
        border-bottom: 2px solid #bdc3c7;
        padding-bottom: 5px;
        margin-bottom: 10px;
      }
      .address-box {
        margin-bottom: 40px;
        font-size: 14px;
        color: #34495e;
      }
      table.items-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 40px;
      }
      table.items-table th {
        background-color: #f8f9fa;
        border-bottom: 2px solid #bdc3c7;
        padding: 12px 10px;
        font-size: 13px;
        font-weight: 700;
        color: #34495e;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      table.items-table td {
        border-bottom: 1px solid #ecf0f1;
        padding: 15px 10px;
        font-size: 14px;
        color: #2c3e50;
      }
      .text-right {
        text-align: right;
      }
      .text-center {
        text-align: center;
      }
      .totals-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
      }
      .totals-box {
        border-top: 2px solid #2980b9;
        padding-top: 15px;
        text-align: right;
        min-width: 250px;
      }
      .totals-label {
        font-size: 12px;
        text-transform: uppercase;
        color: #7f8c8d;
        font-weight: 700;
      }
      .totals-value {
        font-size: 22px;
        font-weight: 800;
        color: #2980b9;
        margin-top: 5px;
      }
      @media print {
        body {
          background-color: #ffffff;
          padding: 0;
        }
        .content-wrapper {
          box-shadow: none;
          margin: 0;
          padding: 15px;
          border-radius: 0;
          max-width: 100%;
        }
      }
    `;

    const bodyHtml = `
      <div class="content-wrapper">
        <table class="header-table">
          <tr>
            <td>
              <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 15px;">
                ${activeLogoUrl ? `<img src="${activeLogoUrl}" style="width: 54px; height: 54px; border-radius: 6px; object-fit: cover;" />` : ""}
                <div class="title" style="margin: 0;">Bid Proposal Quote</div>
              </div>
              <div class="meta-info">
                Proposal Number: <strong>${po.poNumber}</strong><br/>
                Project Name: <strong>${po.title}</strong><br/>
                Date Received from Customer: <strong>${po.receivedFromCustomerDate || po.date || "N/A"}</strong><br/>
                Date Estimate Submitted: <strong>${po.submittedDate || ((po.status === "Bid Submitted" || po.status === "Won" || po.status === "Lost") ? po.date : "Pending Submission")}</strong><br/>
                Estimate Expiration Date: <strong>${po.expirationDate || (po.dueDate || "30 Days from Submission")}</strong><br/>
              </div>
            </td>
            <td class="client-info">
              <span class="client-label">Client Partner</span>
              <div class="client-name">${po.clientName}</div>
            </td>
          </tr>
        </table>
        
        <div class="section-title">Ship To Address</div>
        <div class="address-box">
          ${po.shipToAddress || "N/A"}<br/>
          ${po.shipToAddress2 ? po.shipToAddress2 + "<br/>" : ""}
          ${po.shipToCity || ""}, ${po.shipToState || ""} ${po.shipToZip || ""}
          ${po.markFor ? `<div style="margin-top: 6px; color: #2980b9;"><strong>Mark For (M/F):</strong> ${po.markFor}</div>` : ""}
        </div>
        
        <div class="section-title">Quote Specifications</div>
        <table class="items-table">
          <thead>
            <tr>
              <th class="text-center" style="width: 60px;">Line #</th>
              <th>Description</th>
              <th class="text-center" style="width: 80px;">Qty</th>
              <th class="text-right" style="width: 130px;">Client Price</th>
              <th class="text-right" style="width: 150px;">Total Price</th>
            </tr>
          </thead>
          <tbody>
            ${po.items && po.items.length > 0 ? po.items.map((item, idx) => {
              const lineClientTotal = Number((item.unitPrice !== undefined && item.unitPrice !== null && item.unitPrice !== "")
                ? item.unitPrice
                : recalculateItemClientPrice(item, getItemMarkupRate(item, po), multipliers, null, newDecimal)
              );
              const qty = parseFloat(item.quantity) || 0;
              const unitClientPrice = qty > 0 ? (lineClientTotal / qty) : lineClientTotal;
              const lineNum = item.lineNumber || String(idx + 1).padStart(2, "0");
              return `
                <tr>
                  <td class="text-center" style="font-weight: 600; color: #7f8c8d;">${lineNum}</td>
                  <td>${item.description || "N/A"}</td>
                  <td class="text-center">${qty}</td>
                  <td class="text-right">$${unitClientPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  <td class="text-right">$${lineClientTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                </tr>
              `;
            }).join("") : `
              <tr>
                <td colspan="5" class="text-center" style="color: #95a5a6;">No specifications listed</td>
              </tr>
            `}
          </tbody>
        </table>
        
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-top: 30px;">
          <div style="text-align: left; max-width: 60%; padding-right: 20px;">
            ${po.additionalInfo ? `
              <div style="font-size: 11px; text-transform: uppercase; color: #7f8c8d; font-weight: 700; margin-bottom: 5px;">Note to Customer:</div>
              <div style="font-size: 13px; color: #2c3e50; line-height: 1.6; white-space: pre-wrap;">${po.additionalInfo}</div>
            ` : ""}
          </div>
          <div class="totals-box" style="border-top: 2px solid #2980b9; padding-top: 15px; text-align: right; min-width: 250px;">
            <span class="totals-label">Total Client Price</span>
            <div class="totals-value">$${clientPriceSum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          </div>
        </div>
      </div>
    `;

    openDocumentPrintWindow({
      title: `${po.poNumber} - Bid Proposal`,
      headStyles: styles,
      bodyHtml
    });
  };

  const filteredPOs = pos.filter(po => {
    const matchesSearch = (po.poNumber || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
                          (po.clientName || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
                          (po.title || "").toLowerCase().includes(searchTerm.toLowerCase());
                          
    let matchesTab = false;
    if (activePoTab === "pipeline") {
      matchesTab = po.status === "Received" || po.status === "Draft Bid" || po.status === "Update Bid";
    } else if (activePoTab === "open") {
      matchesTab = po.status === "Bid Submitted";
    } else if (activePoTab === "completed") {
      matchesTab = ["Won", "Lost", "Proposal Lost", "Cancelled", "On Hold", "Not Granted"].includes(po.status);
    }

    const matchesStatus = statusFilter === "All" || po.status === statusFilter;
    const matchesCompanyAssignment = (() => {
      if (!companyLogos || companyLogos.length === 0) return true;
      const poLogoUrl = po.logoUrl || companyLogos.find(l => l.isActive)?.url || "";
      if (companyLogos.some(logo => logo.url === poLogoUrl)) return true;
      if (po.companyName && companyLogos.some(logo => logo.name?.toLowerCase() === po.companyName.toLowerCase())) return true;
      return false;
    })();
    if (!matchesCompanyAssignment) return false;

    if (companyFilter !== "All") {
      const companyName = getCompanyNameForPo(po);
      if (companyName.toLowerCase() !== companyFilter.toLowerCase()) return false;
    }

    return matchesSearch && matchesTab && matchesStatus;
  });

  const getStatusBadge = (status) => {
    switch (status) {
      case "Won": return "badge-success";
      case "Bid Submitted": return "badge-info";
      case "Update Bid": return "badge-success";
      case "Draft Bid": return "badge-warning";
      case "Received": return "badge-info";
      case "Lost":
      case "Proposal Lost":
      case "Cancelled": return "badge-danger";
      case "On Hold":
      case "Not Granted": return "badge-warning";
      default: return "badge-info";
    }
  };

  const getFormattedHref = (url) => {
    if (!url) return "#";
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }
    return `https://${url}`;
  };

  // Helper to render cell values based on dynamic column keys
  const renderCellContent = (colKey, item, po, itemIdx) => {
    const isReadOnly = (po.status === "Bid Submitted" || ["Won", "Lost", "Proposal Lost", "Cancelled", "On Hold", "Not Granted"].includes(po.status)) && !po.changeRequestActive;
    const itemVendors = item.vendors && item.vendors.length > 0 ? item.vendors : [
      { id: 'default', vendor: item.vendor || "", quantity: item.quantity || 0, vendorPrice: item.vendorPrice || 0, shippingCost: item.shippingCost || 0, url: item.url || "" }
    ];
    
    switch (colKey) {
      case "lineNumber":
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px", width: "100%" }}>
            {!isReadOnly && (
              <span
                draggable="true"
                onDragStart={(e) => {
                  e.stopPropagation();
                  handleItemRowDragStart(e, po.id, itemIdx);
                }}
                onDragEnd={handleItemRowDragEnd}
                className="row-drag-handle"
                title="Drag to reorder line items (preserves Line #)"
                style={{ cursor: "grab", display: "inline-flex", alignItems: "center", color: "var(--text-secondary)", flexShrink: 0 }}
              >
                <GripVertical size={14} />
              </span>
            )}
            <input
              type="text"
              className="inline-edit-input text-center"
              value={item.lineNumber || ""}
              disabled={isReadOnly}
              placeholder="01"
              onChange={(e) => handleUpdateItemFieldLocal(po.id, item.id, "lineNumber", e.target.value)}
              onBlur={() => handleSyncItemsToFirestore(po.id)}
              onFocus={(e) => e.target.select()}
              onClick={(e) => e.target.select()}
              style={{ fontWeight: "bold", width: !isReadOnly ? "calc(100% - 18px)" : "100%" }}
            />
          </div>
        );
      case "description":
        return (
          <DescriptionCell
            poId={po.id}
            item={item}
            isReadOnly={isReadOnly}
            handleUpdateItemFieldLocal={handleUpdateItemFieldLocal}
            handleSyncItemsToFirestore={handleSyncItemsToFirestore}
          />
        );
      case "quantity":
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
            {itemVendors.map((v, vIdx) => (
              <div key={v.id} style={{ display: "flex", alignItems: "center", height: "32px" }}>
                <input
                  type="number"
                  className="inline-edit-input text-center"
                  value={v.quantity}
                  min="0"
                  disabled={isReadOnly}
                  onChange={(e) => handleUpdateVendorFieldLocal(po.id, item.id, v.id, "quantity", e.target.value)}
                  onBlur={() => handleSyncItemsToFirestore(po.id)}
                  onWheel={(e) => e.target.blur()}
                  onFocus={(e) => e.target.select()}
                  onClick={(e) => e.target.select()}
                  style={{ width: "100%" }}
                />
              </div>
            ))}
          </div>
        );
      case "cuc": {
        const multipliers = calculateVendorShippingMultipliers(po.items);
        const shippingOut = getPoShippingCostOut(po);
        const totalCost = calculateTotalCostSum(po.items, null, multipliers);
        const newDecimal = calculateNewDecimal(shippingOut, totalCost);
        const clientPriceVal = Number((item.unitPrice !== undefined && item.unitPrice !== null && item.unitPrice !== "")
          ? item.unitPrice 
          : recalculateItemClientPrice(item, getItemMarkupRate(item, po), multipliers, null, newDecimal)
        );
        const qty = parseFloat(item.quantity) || 0;
        const cucVal = qty > 0 ? (clientPriceVal / qty) : 0;
        return (
          <div 
            style={{ fontWeight: 500, color: "var(--text-secondary)", paddingRight: "0.5rem", textAlign: "right" }}
            title={`Client Unit Cost: $${(isNaN(cucVal) ? 0 : cucVal).toFixed(2)}`}
          >
            ${(isNaN(cucVal) ? 0 : cucVal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        );
      }
      case "unitPrice": {
        const multipliers = calculateVendorShippingMultipliers(po.items);
        const shippingOut = getPoShippingCostOut(po);
        const totalCost = calculateTotalCostSum(po.items, null, multipliers);
        const newDecimal = calculateNewDecimal(shippingOut, totalCost);
        const clientPriceVal = Number((item.unitPrice !== undefined && item.unitPrice !== null && item.unitPrice !== "")
          ? item.unitPrice 
          : recalculateItemClientPrice(item, getItemMarkupRate(item, po), multipliers, null, newDecimal)
        );
        return (
          <div style={{ fontWeight: 600, color: "var(--text-primary)", paddingRight: "0.5rem", textAlign: "right" }}>
            ${(isNaN(clientPriceVal) ? 0 : clientPriceVal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        );
      }
      case "vendor":
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem", width: "100%" }}>
            {itemVendors.map((v, vIdx) => (
              <div key={v.id} style={{ display: "flex", alignItems: "center", gap: "0.25rem", height: "32px", width: "100%" }}>
                <input
                  type="text"
                  className="inline-edit-input"
                  value={v.vendor || ""}
                  disabled={isReadOnly}
                  placeholder="Vendor supplier"
                  list={`vendors-list-${item.id}-${v.id}-${po.id}`}
                  onChange={(e) => {
                    handleUpdateVendorFieldLocal(po.id, item.id, v.id, "vendor", e.target.value);
                  }}
                  onBlur={() => handleSyncItemsToFirestore(po.id)}
                  autoComplete="off"
                  style={{ flex: 1 }}
                />
                <datalist id={`vendors-list-${item.id}-${v.id}-${po.id}`}>
                  {vendors.map(vendor => (
                    <option key={vendor.id} value={vendor.name}>
                      {vendor.category ? `${vendor.name} (${vendor.category})` : vendor.name}
                    </option>
                  ))}
                </datalist>
                {itemVendors.length > 1 && !isReadOnly && (
                  <button
                    type="button"
                    onClick={() => handleRemoveVendorSplit(po.id, item.id, v.id)}
                    style={{ background: "transparent", border: "none", color: "var(--danger)", cursor: "pointer", display: "flex", alignItems: "center", padding: "0 0.2rem" }}
                    title="Remove split"
                  >
                    <Trash2 size={12} />
                  </button>
                )}
              </div>
            ))}
          </div>
        );
      case "tagSearch":
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem", alignItems: "center" }}>
            {itemVendors.map((v, vIdx) => (
              <div key={v.id} style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "32px" }}>
                {!isReadOnly && (
                  <button
                    type="button"
                    className="btn btn-secondary btn-icon"
                    onClick={() => {
                      setTagSearchTarget({ poId: po.id, itemId: item.id, vendorId: v.id });
                      setTagSearchModalOpen(true);
                    }}
                    title="Search Vendor by Product or Brand Tag"
                    style={{
                      width: "24px",
                      height: "24px",
                      minHeight: "auto",
                      padding: 0,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "4px",
                      color: "var(--primary)",
                      borderColor: "var(--border-color)",
                      backgroundColor: "rgba(255, 255, 255, 0.03)"
                    }}
                  >
                    <Search size={14} />
                  </button>
                )}
              </div>
            ))}
          </div>
        );
      case "splitVendor":
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem", alignItems: "center" }}>
            {itemVendors.map((v, vIdx) => (
              <div key={v.id} style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "32px" }}>
                {!isReadOnly && (
                  <button
                    type="button"
                    className="btn btn-secondary btn-icon"
                    onClick={() => handleAddVendorSplit(po.id, item.id)}
                    title="Split Vendor"
                    style={{
                      width: "24px",
                      height: "24px",
                      minHeight: "auto",
                      padding: 0,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "4px",
                      color: "var(--primary)",
                      borderColor: "var(--border-color)",
                      backgroundColor: "rgba(255, 255, 255, 0.03)"
                    }}
                  >
                    <Plus size={14} />
                  </button>
                )}
              </div>
            ))}
          </div>
        );
      case "vendorPrice":
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
            {itemVendors.map((v, vIdx) => (
              <div key={v.id} style={{ display: "flex", alignItems: "center", height: "32px" }}>
                <input
                  type="number"
                  step="0.01"
                  className="inline-edit-input text-right"
                  value={v.vendorPrice || ""}
                  min="0"
                  disabled={isReadOnly}
                  placeholder="0.00"
                  onChange={(e) => handleUpdateVendorFieldLocal(po.id, item.id, v.id, "vendorPrice", e.target.value)}
                  onBlur={() => handleSyncItemsToFirestore(po.id)}
                  onWheel={(e) => e.target.blur()}
                  onFocus={(e) => e.target.select()}
                  onClick={(e) => e.target.select()}
                  style={{ width: "100%" }}
                />
              </div>
            ))}
          </div>
        );
      case "tax":
        const globalTaxRate = getDefaultTaxRate();
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
            {itemVendors.map((v) => {
              const isChecked = v.isTaxable !== false && v.tax !== false && v.tax !== "false";
              return (
                <div key={v.id} style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "32px" }}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    disabled={isReadOnly}
                    title={isChecked ? `Taxable (${globalTaxRate}%)` : "Non-taxable (0%)"}
                    onChange={(e) => handleToggleItemTax(po.id, item.id, v.id, e.target.checked)}
                    style={{
                      width: "16px",
                      height: "16px",
                      cursor: isReadOnly ? "default" : "pointer",
                      accentColor: "var(--primary)",
                      margin: 0
                    }}
                  />
                </div>
              );
            })}
          </div>
        );
      case "shippingCost":
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
            {itemVendors.map((v, vIdx) => (
              <div key={v.id} style={{ display: "flex", alignItems: "center", height: "32px" }}>
                <input
                  type="number"
                  step="0.01"
                  className="inline-edit-input text-right"
                  value={v.shippingCost || ""}
                  min="0"
                  disabled={isReadOnly}
                  placeholder="0.00"
                  onChange={(e) => handleUpdateVendorFieldLocal(po.id, item.id, v.id, "shippingCost", e.target.value)}
                  onBlur={() => handleSyncItemsToFirestore(po.id)}
                  onWheel={(e) => e.target.blur()}
                  onFocus={(e) => e.target.select()}
                  onClick={(e) => e.target.select()}
                  style={{ width: "100%" }}
                />
              </div>
            ))}
          </div>
        );
      case "staff":
        const staffFullName = getStaffFullName(item.staff);
        const staffInitials = getStaffInitials(item.staff);

        if (isReadOnly) {
          return (
            <div 
              style={{ 
                textAlign: "center", 
                fontWeight: 600, 
                color: "var(--text-primary)",
                cursor: staffFullName ? "help" : "default",
                fontSize: "0.85rem"
              }}
              title={staffFullName || undefined}
            >
              {staffInitials || "—"}
            </div>
          );
        }

        return (
          <div style={{ display: "flex", justifyContent: "center", width: "100%" }} title={staffFullName || "Select Staff"}>
            <select
              className="inline-edit-input"
              value={item.staff || ""}
              disabled={isReadOnly}
              onChange={(e) => handleUpdateItemFieldLocal(po.id, item.id, "staff", e.target.value)}
              onBlur={() => handleSyncItemsToFirestore(po.id)}
              title={staffFullName || "Select Staff"}
              style={{ 
                color: isReadOnly ? "var(--text-primary)" : "var(--text-primary)", 
                backgroundColor: isReadOnly ? "transparent" : "var(--bg-input)",
                borderColor: isReadOnly ? "transparent" : "var(--border-color)",
                padding: "0.25rem 0.1rem",
                borderRadius: "4px",
                border: isReadOnly ? "1px solid transparent" : "1px solid var(--border-color)",
                cursor: isReadOnly ? "default" : "pointer",
                outline: "none",
                textAlign: "center",
                textAlignLast: "center",
                fontWeight: 600,
                fontSize: "0.85rem",
                width: "100%"
              }}
            >
              <option value="" style={{ color: "var(--text-primary)", backgroundColor: "var(--bg-card)" }}>—</option>
              {procurementUsers.map(u => (
                <option key={u.value} value={u.value} title={u.label} style={{ color: "var(--text-primary)", backgroundColor: "var(--bg-card)" }}>
                  {getStaffInitials(u.value)}
                </option>
              ))}
            </select>
          </div>
        );
      case "markupPercentage":
        const displayMarkup = getItemMarkupDisplay(item, po);
        return (
          <div
            onClick={() => {
              if (!isReadOnly) {
                setSelectedMarkupItem(item);
                setSelectedMarkupPo(po);
                setCustomMarkupModalOpen(true);
              }
            }}
            style={{
              cursor: isReadOnly ? "default" : "pointer",
              fontWeight: item.isMarkupCustom ? "bold" : "normal",
              color: item.isMarkupCustom ? "var(--success)" : "var(--text-secondary)",
              textAlign: "center",
              width: "100%",
              padding: "0.25rem 0",
              borderRadius: "4px",
              backgroundColor: item.isMarkupCustom ? "rgba(46, 204, 113, 0.05)" : "transparent"
            }}
            title={item.isMarkupCustom ? "Custom markup set. Click to edit." : "Inherits EST markup. Click to customize."}
          >
            {displayMarkup}
          </div>
        );
      case "totalCharge": {
        const multipliers = calculateVendorShippingMultipliers(po.items);
        const totalLineCost = calculateLineTotalCost(item, multipliers);
        return (
          <div style={{ fontWeight: 600, color: "var(--text-primary)", paddingRight: "0.5rem", textAlign: "right" }}>
            ${totalLineCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        );
      }
      case "actions": {
        const isMenuOpen = activeInsertMenu?.itemId === item.id;
        const hasNotes = (item.logs && item.logs.length > 0) || item.notes || (item.vendors && item.vendors.some(v => v.logs && v.logs.length > 0));
        return (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem" }}>
            <button
              type="button"
              className="invoice-item-action-btn"
              onClick={(e) => {
                e.stopPropagation();
                setLineNotesModal({ open: true, po, item });
              }}
              title={hasNotes ? "View/Add Line Notes (Notes exist)" : "Add Line Note"}
              style={{
                background: "transparent",
                border: "none",
                color: hasNotes ? "var(--primary)" : "var(--text-secondary)",
                cursor: "pointer",
                padding: "0.2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                position: "relative",
                transition: "all 0.15s ease"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "var(--primary)";
                e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = hasNotes ? "var(--primary)" : "var(--text-secondary)";
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <MessageSquare size={15} />
              {hasNotes && (
                <span style={{
                  position: "absolute",
                  top: "1px",
                  right: "1px",
                  width: "5px",
                  height: "5px",
                  borderRadius: "50%",
                  backgroundColor: "var(--primary)"
                }} />
              )}
            </button>
            {!isReadOnly && (
              <>
                <div className="insert-line-popover-container" style={{ position: "relative" }}>
                  <button
                    type="button"
                    className="invoice-item-action-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setActiveInsertMenu(isMenuOpen ? null : { itemId: item.id, poId: po.id, index: itemIdx });
                    }}
                    title="Insert line above or below"
                    style={{
                      background: isMenuOpen ? "rgba(255, 255, 255, 0.1)" : "transparent",
                      border: "none",
                      color: isMenuOpen ? "var(--primary)" : "var(--text-secondary)",
                      cursor: "pointer",
                      padding: "0.2rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "4px",
                      transition: "all 0.15s ease"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = "var(--primary)";
                      e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
                    }}
                    onMouseLeave={(e) => {
                      if (!isMenuOpen) {
                        e.currentTarget.style.color = "var(--text-secondary)";
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <ListPlus size={15} />
                  </button>

                  {isMenuOpen && (
                    <div 
                      className="insert-line-popover animate-fade-in"
                      style={{
                        position: "absolute",
                        right: 0,
                        bottom: "100%",
                        marginBottom: "6px",
                        zIndex: 1000,
                        backgroundColor: "var(--bg-card)",
                        border: "1px solid var(--border-color)",
                        borderRadius: "6px",
                        boxShadow: "0 6px 20px rgba(0,0,0,0.5)",
                        padding: "0.25rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                        minWidth: "135px"
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        type="button"
                        onClick={() => {
                          handleInsertLineItemDirect(po, itemIdx, "above");
                          setActiveInsertMenu(null);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          padding: "0.4rem 0.6rem",
                          fontSize: "0.8rem",
                          background: "transparent",
                          border: "none",
                          color: "var(--text-primary)",
                          borderRadius: "4px",
                          cursor: "pointer",
                          textAlign: "left",
                          width: "100%"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                      >
                        <ArrowUp size={13} style={{ color: "var(--primary)" }} /> Insert Above
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          handleInsertLineItemDirect(po, itemIdx, "below");
                          setActiveInsertMenu(null);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          padding: "0.4rem 0.6rem",
                          fontSize: "0.8rem",
                          background: "transparent",
                          border: "none",
                          color: "var(--text-primary)",
                          borderRadius: "4px",
                          cursor: "pointer",
                          textAlign: "left",
                          width: "100%"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                      >
                        <ArrowDown size={13} style={{ color: "var(--primary)" }} /> Insert Below
                      </button>
                    </div>
                  )}
                </div>

                <button
                  type="button"
                  className="invoice-item-delete"
                  onClick={() => handleDeleteLineItem(po, item.id)}
                  title="Delete Line"
                >
                  <Trash2 size={14} />
                </button>
              </>
            )}
          </div>
        );
      }
      default:
        return null;
    }
  };

  return (
    <div className="animate-fade-in">
      <div className="page-header">
        <div className="page-header-info">
          <h1>Client Requests for Quotes</h1>
          <p>Click on any EST row below to fold open the spreadsheet sheet, edit cell contents directly, and submit proposals.</p>
        </div>
        <button className="btn btn-primary" onClick={handleOpenAddModal}>
          <Plus size={18} />
          Receive Client EST
        </button>
      </div>

      {/* PO Tabs */}
      <div className="po-tabs-container" style={{
        display: "flex",
        gap: "1rem",
        marginBottom: "1.5rem",
        borderBottom: "1px solid var(--border-color)",
        paddingBottom: "0.5rem"
      }}>
        <button
          className={`po-tab-btn ${activePoTab === "pipeline" ? "active" : ""}`}
          onClick={() => {
            setActivePoTab("pipeline");
            setStatusFilter("All");
            setExpandedPoId(null);
          }}
          style={{
            background: "none",
            border: "none",
            color: activePoTab === "pipeline" ? "var(--primary)" : "var(--text-secondary)",
            fontSize: "1rem",
            fontWeight: "600",
            padding: "0.5rem 1rem",
            cursor: "pointer",
            transition: "all 0.2s",
            borderRadius: "4px",
            backgroundColor: activePoTab === "pipeline" ? "rgba(255, 255, 255, 0.05)" : "transparent"
          }}
        >
          Estimate Workspace
        </button>
        <button
          className={`po-tab-btn ${activePoTab === "open" ? "active" : ""}`}
          onClick={() => {
            setActivePoTab("open");
            setStatusFilter("All");
            setExpandedPoId(null);
          }}
          style={{
            background: "none",
            border: "none",
            color: activePoTab === "open" ? "var(--primary)" : "var(--text-secondary)",
            fontSize: "1rem",
            fontWeight: "600",
            padding: "0.5rem 1rem",
            cursor: "pointer",
            transition: "all 0.2s",
            borderRadius: "4px",
            backgroundColor: activePoTab === "open" ? "rgba(255, 255, 255, 0.05)" : "transparent"
          }}
        >
          Open Estimates
        </button>
        <button
          className={`po-tab-btn ${activePoTab === "completed" ? "active" : ""}`}
          onClick={() => {
            setActivePoTab("completed");
            setStatusFilter("All");
            setExpandedPoId(null);
          }}
          style={{
            background: "none",
            border: "none",
            color: activePoTab === "completed" ? "var(--primary)" : "var(--text-secondary)",
            fontSize: "1rem",
            fontWeight: "600",
            padding: "0.5rem 1rem",
            cursor: "pointer",
            transition: "all 0.2s",
            borderRadius: "4px",
            backgroundColor: activePoTab === "completed" ? "rgba(255, 255, 255, 0.05)" : "transparent"
          }}
        >
          Completed Estimates
        </button>
      </div>

      {/* Filter and Search Bar */}
      <div className="table-actions-container">
        <div className="search-box-container">
          <Search size={18} className="search-icon" />
          <input
            type="text"
            className="form-input search-input"
            placeholder="Search ESTs by EST #, Client, or Project name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="filter-select-group" style={{ display: "flex", gap: "0.5rem" }}>
          <select
            className="form-input filter-select"
            value={companyFilter}
            onChange={(e) => setCompanyFilter(e.target.value)}
            style={{ minWidth: "160px" }}
          >
            <option value="All">All Companies</option>
            {availableCompanyNames.map((name) => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select>
          {activePoTab !== "open" && (
            <select
              className="form-input filter-select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="All">All Statuses</option>
              {activePoTab === "pipeline" && (
                <>
                  <option value="Received">Received</option>
                  <option value="Draft Bid">Draft Bid</option>
                  <option value="Update Bid">Update Bid</option>
                </>
              )}
              {activePoTab === "completed" && (
                <>
                  <option value="Won">Won</option>
                  <option value="Lost">Lost</option>
                  <option value="Proposal Lost">Proposal Lost</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="On Hold">On Hold</option>
                  <option value="Not Granted">Not Granted</option>
                </>
              )}
            </select>
          )}
        </div>
      </div>

      {/* List Layout with Fold-Down Accordion */}
      {loading && pos.length === 0 ? (
        <div className="loading-container">
          <Loader2 className="spinner-icon" size={36} />
          <span>Synchronizing client ESTs board...</span>
        </div>
      ) : filteredPOs.length === 0 ? (
        <div className="empty-state-card">
          <FileText size={48} className="empty-state-icon" />
          <h3>No Client ESTs Found</h3>
          <p>Create a Client EST log entry to start preparing quotes.</p>
        </div>
      ) : (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th style={{ width: "40px" }}></th>
                <th>EST Number</th>
                <th>Client</th>
                <th>Project Name</th>
                <th>Request Date</th>
                <th>Est. Bid Value</th>
                <th>Status</th>
                {canDeleteEstimate && <th style={{ width: "50px", textAlign: "center" }}>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {filteredPOs.map((po) => {
                const isExpanded = expandedPoId === po.id;
                const isReadOnly = (po.status === "Bid Submitted" || ["Won", "Lost", "Proposal Lost", "Cancelled", "On Hold", "Not Granted"].includes(po.status)) && !po.changeRequestActive;
                return (
                  <React.Fragment key={po.id}>
                    {/* Main Row - Clickable anywhere to fold down */}
                    <tr
                      onClick={() => toggleRowExpand(po.id)}
                      className={`clickable-po-row ${isExpanded ? "row-expanded-active" : ""}`}
                    >
                      <td style={{ textAlign: "center" }}>
                        {isExpanded ? <ChevronUp size={16} className="text-secondary" /> : <ChevronDown size={16} className="text-secondary" />}
                      </td>
                      <td>
                        <div style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
                          {getPoLogoUrl(po) && (
                            <img 
                              src={getPoLogoUrl(po)} 
                              alt="Company logo" 
                              style={{ width: "24px", height: "24px", borderRadius: "4px", objectFit: "cover" }} 
                            />
                          )}
                          <span className="sku-badge">{po.poNumber}</span>
                          {po.isPriority && (
                            <span className="priority-pill">PRIORITY</span>
                          )}
                        </div>
                        {po.title && <span className="po-project-label"> — {po.title}</span>}
                      </td>
                      <td style={{ fontWeight: 600, color: "var(--text-primary)" }}>{po.clientName}</td>
                      <td>{po.title}</td>
                      <td>{po.date}</td>
                      <td style={{ fontFamily: "var(--font-heading)", fontWeight: 700, color: "var(--text-primary)" }}>
                        ${calculateProposedClientCharge(po).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                      <td>
                        {activePoTab === "open" ? (
                          <select
                            value={po.status}
                            onChange={(e) => handleOpenPoStatusChange(po, e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            className="form-input status-select"
                            style={{
                              padding: "0.25rem 0.5rem",
                              fontSize: "0.85rem",
                              height: "auto",
                              width: "140px",
                              backgroundColor: "var(--bg-input)",
                              color: "var(--text-primary)",
                              borderColor: "var(--border-color)",
                              borderRadius: "4px"
                            }}
                          >
                            <option value="Bid Submitted">Bid Submitted</option>
                            <option value="Won">Won</option>
                            <option value="Proposal Lost">Proposal Lost</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="On Hold">On Hold</option>
                            <option value="Not Granted">Not Granted</option>
                          </select>
                        ) : (
                          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                            <span className={`badge ${getStatusBadge(po.status)}`}>
                              {po.status}
                            </span>
                            {po.status === "Won" && po.awardedDate && (
                              <span style={{ fontSize: "0.75rem", color: "var(--text-muted)", whiteSpace: "nowrap" }}>
                                Awarded: {po.awardedDate}
                              </span>
                            )}
                          </div>
                        )}
                      </td>
                      {canDeleteEstimate && (
                        <td style={{ textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                          <button
                            type="button"
                            className="btn btn-secondary btn-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenEditEstimateModal(po);
                            }}
                            title="Edit Estimate Details"
                            style={{
                              color: "var(--primary)",
                              borderColor: "transparent",
                              background: "transparent",
                              padding: "0.25rem",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              marginRight: "0.25rem"
                            }}
                          >
                            <Edit3 size={16} />
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              setEstimateToDelete(po);
                              setDeleteEstimateModalOpen(true);
                            }}
                            title="Delete Estimate completely"
                            style={{
                              color: "var(--danger)",
                              borderColor: "transparent",
                              background: "transparent",
                              padding: "0.25rem",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer"
                            }}
                          >
                            <Trash2 size={16} />
                          </button>
                        </td>
                      )}
                    </tr>

                    {/* Fold-down Expanded Content Section */}
                    {isExpanded && (
                      <tr className="expanded-accordion-row">
                        <td colSpan={canDeleteEstimate ? "8" : "7"}>
                          <div className="fold-down-container animate-slide-up">
                            {/* Invoice Layout Sheet */}
                            <div className="invoice-layout-sheet">
                              <div className="invoice-sheet-header">
                                <div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap", marginBottom: "0.25rem" }}>
                                    <span className="invoice-meta-tag" style={{ margin: 0 }}>BID PROPOSAL SPECIFICATIONS</span>
                                    {po.isPriority && (
                                      <span className="priority-pill">PRIORITY</span>
                                    )}
                                    {po.status === "Won" && (
                                      <span className={`badge ${po.changeRequestActive ? "badge-warning" : "badge-secondary"}`} style={{ fontSize: "0.7rem", padding: "0.25rem 0.5rem" }}>
                                        {po.changeRequestActive ? "Change Request Active" : "Locked (Read-Only)"}
                                      </span>
                                    )}
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexWrap: "wrap" }}>
                                    <h2 style={{ margin: 0 }}>{po.poNumber}</h2>
                                    {!isReadOnly && (
                                      <label style={{ display: "inline-flex", alignItems: "center", gap: "0.35rem", cursor: "pointer", userSelect: "none", fontSize: "0.8rem", color: "var(--text-secondary)", marginLeft: "0.5rem" }}>
                                        <input
                                          type="checkbox"
                                          checked={!!po.isPriority}
                                          onChange={async (e) => {
                                            const newPriority = e.target.checked;
                                            try {
                                              await updatePO(po.id, { isPriority: newPriority });
                                              setPos(prev => prev.map(p => p.id === po.id ? { ...p, isPriority: newPriority } : p));
                                            } catch (err) {
                                              console.error("Failed to toggle priority:", err);
                                            }
                                          }}
                                          style={{ width: "14px", height: "14px", accentColor: "#f59e0b", cursor: "pointer" }}
                                        />
                                        <span>Priority</span>
                                      </label>
                                    )}
                                  </div>
                                  {po.customerPoNumber && (
                                    <div style={{ fontSize: "0.85rem", color: "var(--text-secondary)", marginTop: "0.2rem" }}>
                                      <strong>Customer PO #:</strong> {po.customerPoNumber}
                                    </div>
                                  )}
                                  <span className="invoice-project-title">{po.title}</span>
                                  {po.shipToAddress && (
                                    <div style={{ fontSize: "0.85rem", color: "var(--text-secondary)", marginTop: "0.5rem" }}>
                                      <strong>Ship To:</strong> {po.shipToAddress}
                                      {po.shipToAddress2 ? `, ${po.shipToAddress2}` : ""}, {po.shipToCity}, {po.shipToState} {po.shipToZip}
                                    </div>
                                  )}
                                  {po.markFor && (
                                    <div style={{ fontSize: "0.85rem", color: "var(--text-secondary)", marginTop: "0.25rem" }}>
                                      <strong>Mark For (M/F):</strong> {po.markFor}
                                    </div>
                                  )}
                                  {po.status === "Update Bid" && po.updateBidReason && (
                                    <div style={{
                                      backgroundColor: "rgba(255, 193, 7, 0.1)",
                                      border: "1px solid rgba(255, 193, 7, 0.3)",
                                      padding: "0.5rem 0.75rem",
                                      borderRadius: "6px",
                                      marginTop: "0.5rem",
                                      fontSize: "0.85rem",
                                      color: "#ffc107",
                                      maxWidth: "400px",
                                      textAlign: "left"
                                    }}>
                                      <strong>Update Bid Reason:</strong> {po.updateBidReason}
                                    </div>
                                  )}
                                </div>
                                <div style={{ textAlign: "right", display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.75rem" }}>
                                  <div>
                                    <span className="invoice-label">CLIENT PARTNER</span>
                                    <div className="invoice-client-name-bold">{po.clientName}</div>
                                    <div className="invoice-meta-detail">Request Date: <strong>{po.date}</strong></div>
                                    {po.receivedFromCustomerDate && (
                                      <div className="invoice-meta-detail" style={{ marginTop: "0.25rem" }}>
                                        Received: <strong>{po.receivedFromCustomerDate}</strong>
                                      </div>
                                    )}
                                    {po.submittedDate && (
                                      <div className="invoice-meta-detail" style={{ marginTop: "0.25rem" }}>
                                        Submitted: <strong>{po.submittedDate}</strong>
                                      </div>
                                    )}
                                    {po.expirationDate && (
                                      <div className="invoice-meta-detail" style={{ marginTop: "0.25rem" }}>
                                        Expires: <strong>{po.expirationDate}</strong>
                                      </div>
                                    )}
                                    {po.dueDate && <div className="invoice-meta-detail" style={{ marginTop: "0.25rem" }}>Due Date: <strong>{po.dueDate}</strong></div>}
                                  </div>
                                  
                                  <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", justifyContent: "flex-end" }}>
                                    <button
                                      type="button"
                                      className="btn btn-secondary"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleOpenEditEstimateModal(po);
                                      }}
                                      style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        gap: "0.35rem", 
                                        padding: "0.4rem 0.8rem", 
                                        fontSize: "0.85rem", 
                                        minHeight: "auto", 
                                        color: "var(--text-primary)", 
                                        borderColor: "var(--border-color)", 
                                        backgroundColor: "transparent" 
                                      }}
                                      title="Edit estimate details (reopen Receive Estimate modal)"
                                    >
                                      <Edit3 size={14} />
                                      Edit Details
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-secondary"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setAdditionalInfoPo(po);
                                        setTempAdditionalInfo(po.additionalInfo || "");
                                        setAdditionalInfoModalOpen(true);
                                      }}
                                      style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        gap: "0.35rem", 
                                        padding: "0.4rem 0.8rem",
                                        fontSize: "0.85rem",
                                        minHeight: "auto",
                                        color: "var(--text-primary)",
                                        borderColor: "var(--border-color)",
                                        backgroundColor: "transparent"
                                      }}
                                      title="Edit Note to Customer"
                                    >
                                      <Info size={14} />
                                      Note to Customer
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-secondary"
                                      onClick={() => setSelectedTasksPo(po)}
                                      style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        gap: "0.5rem", 
                                        padding: "0.4rem 0.8rem",
                                        fontSize: "0.85rem",
                                        minHeight: "auto"
                                      }}
                                      title="View & manage tasks for this Estimate"
                                    >
                                      <CheckSquare size={14} />
                                      Tasks
                                    </button>
                                    {po.status === "Won" && (
                                      <button
                                        type="button"
                                        className="btn btn-warning"
                                        disabled={isPoFullyDelivered(po)}
                                        onClick={() => setSelectedChangeRequestPo(po)}
                                        style={{ 
                                          display: "flex", 
                                          alignItems: "center", 
                                          gap: "0.5rem", 
                                          padding: "0.4rem 0.8rem",
                                          fontSize: "0.85rem",
                                          minHeight: "auto",
                                          color: "#000000",
                                          opacity: isPoFullyDelivered(po) ? 0.4 : 1,
                                          cursor: isPoFullyDelivered(po) ? "not-allowed" : "pointer"
                                        }}
                                        title={isPoFullyDelivered(po) ? "All line items have been delivered. No changes can be made." : "Open Change Request modal"}
                                      >
                                        <Sliders size={14} color="#000000" />
                                        Change Request
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      className="btn btn-secondary"
                                      onClick={() => handleGeneratePDF(po)}
                                      disabled={!po.items || po.items.length === 0}
                                      style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        gap: "0.5rem", 
                                        padding: "0.4rem 0.8rem", 
                                        fontSize: "0.85rem", 
                                        minHeight: "auto" 
                                      }}
                                      title="Export Bid Proposal to PDF"
                                    >
                                      <FileText size={14} />
                                      Export to PDF
                                    </button>
                                    {(po.status === "Received" || po.status === "Draft Bid" || po.status === "Update Bid") && (() => {
                                      const totalMaterialCost = calculateTotalCostSum(po.items);
                                      const totalEstimateAmount = calculateProposedClientCharge(po);
                                      const profit = totalEstimateAmount - totalMaterialCost;
                                      const isZeroOrNegative = profit <= 0.0001;

                                      return (
                                        <button
                                          className="btn btn-primary"
                                          onClick={() => handleOpenSubmitModal(po)}
                                          title={
                                            isZeroOrNegative && !isManagerOrAdmin
                                              ? "Manager or Admin approval required to submit this estimate (projected profit is $0.00 or negative)"
                                              : isZeroOrNegative && isManagerOrAdmin
                                              ? "Projected profit is $0.00 or negative - Manager approval required"
                                              : "Ready to Submit to Client"
                                          }
                                          style={{ 
                                            display: "flex", 
                                            alignItems: "center", 
                                            gap: "0.5rem", 
                                            background: isZeroOrNegative && !isManagerOrAdmin ? "var(--warning)" : "var(--success)", 
                                            borderColor: isZeroOrNegative && !isManagerOrAdmin ? "var(--warning)" : "var(--success)", 
                                            color: "#000000", 
                                            padding: "0.4rem 0.8rem", 
                                            fontSize: "0.85rem", 
                                            minHeight: "auto" 
                                          }}
                                        >
                                          {isZeroOrNegative && !isManagerOrAdmin ? (
                                            <AlertTriangle size={14} color="#000000" />
                                          ) : (
                                            <CheckCircle size={14} color="#000000" />
                                          )}
                                          {isZeroOrNegative && !isManagerOrAdmin ? "Manager Approval Req." : "Ready to Submit"}
                                        </button>
                                      );
                                    })()}
                                    <button
                                      className="btn btn-secondary"
                                      onClick={() => setSelectedChatPo(po)}
                                      style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        gap: "0.5rem", 
                                        padding: "0.4rem 0.8rem",
                                        fontSize: "0.85rem",
                                        minHeight: "auto"
                                      }}
                                    >
                                      <MessageSquare size={14} />
                                      Chat
                                    </button>
                                    {canDeleteEstimate && (
                                      <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setEstimateToDelete(po);
                                          setDeleteEstimateModalOpen(true);
                                        }}
                                        style={{ 
                                          display: "flex", 
                                          alignItems: "center", 
                                          gap: "0.4rem", 
                                          padding: "0.4rem 0.8rem",
                                          fontSize: "0.85rem",
                                          minHeight: "auto",
                                          color: "var(--danger)",
                                          borderColor: "var(--border-color)",
                                          backgroundColor: "transparent"
                                        }}
                                        title="Delete Estimate completely"
                                      >
                                        <Trash2 size={14} />
                                        Delete EST
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Draggable drag indicator notice with tooltip, separate from magnifier search button */}
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "1rem", marginBottom: "0.5rem" }}>
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setTagSearchModalOpen(true);
                                  }}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: "0.25rem",
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "var(--primary)",
                                    transition: "transform 0.2s, color 0.2s"
                                  }}
                                  title="Search Vendors by Product or Brand Tag"
                                >
                                  <Search size={32} />
                                </button>

                                <div className="drag-column-info" onClick={(e) => e.stopPropagation()} style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", width: "auto", margin: 0 }}>
                                  <div className="tooltip-container">
                                    <HelpCircle size={16} style={{ color: "var(--primary)", cursor: "help" }} />
                                    <span className="tooltip-text">Tip: Click and drag any table header to reorder columns. Drop highlights show insert points.</span>
                                  </div>
                                  <Move size={14} style={{ color: "var(--primary)" }} />
                                </div>
                              </div>

                              {/* Line Items Table with inline edits and draggable columns */}
                              <div className="invoice-table-wrapper" onClick={(e) => e.stopPropagation()} style={{ marginTop: "0.75rem" }}>
                                <table className="invoice-table">
                                  <thead>
                                    <tr>
                                      {columnOrder.map((colKey, colIdx) => {
                                        const isDragOver = dragOverIndex === colIdx;
                                        const isDragged = draggedIndex === colIdx;
                                        const colTooltip = colKey === "shippingCost" ? "Vendor Shipping Cost" : colKey === "cuc" ? "Client Unit Cost" : undefined;
                                        return (
                                          <th
                                            key={colKey}
                                            draggable="true"
                                            onDragStart={(e) => handleDragStart(e, colIdx)}
                                            onDragOver={(e) => handleDragOver(e, colIdx)}
                                            onDragEnd={handleDragEnd}
                                            onDrop={(e) => handleDrop(e, colIdx)}
                                            className={`draggable-th ${isDragOver ? "drag-over" : ""} ${isDragged ? "dragging" : ""}`}
                                            style={columnStyles[colKey]}
                                            title={colTooltip}
                                          >
                                            <span className="drag-column-label" title={colTooltip}>{columnHeaders[colKey]}</span>
                                          </th>
                                        );
                                      })}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(!po.items || po.items.length === 0) ? (
                                      <tr>
                                        <td colSpan={columnOrder.length} className="invoice-empty-rows">
                                          No specifications drafted yet. Click "Add Line Item" below to build lines.
                                        </td>
                                      </tr>
                                    ) : (
                                      po.items.map((item, itemIdx) => {
                                        const isRowDragged = draggedItemPoId === po.id && draggedItemIndex === itemIdx;
                                        const isRowDragOver = draggedItemPoId === po.id && dragOverItemIndex === itemIdx && draggedItemIndex !== itemIdx;
                                        return (
                                          <tr
                                            key={item.id}
                                            onDragOver={(e) => {
                                              if (draggedItemPoId === po.id) {
                                                handleItemRowDragOver(e, po.id, itemIdx);
                                              }
                                            }}
                                            onDrop={(e) => {
                                              if (draggedItemPoId === po.id) {
                                                handleItemRowDrop(e, po.id, itemIdx);
                                              }
                                            }}
                                            className={`${isRowDragOver ? "item-row-drag-over" : ""} ${isRowDragged ? "item-row-dragging" : ""}`}
                                          >
                                            {columnOrder.map((colKey, colIdx) => {
                                              const isDragOver = dragOverIndex === colIdx;
                                              return (
                                                <td
                                                  key={colKey}
                                                  className={isDragOver ? "drag-over" : ""}
                                                  style={columnStyles[colKey]}
                                                >
                                                  {renderCellContent(colKey, item, po, itemIdx)}
                                                </td>
                                              );
                                            })}
                                          </tr>
                                        );
                                      })
                                    )}
                                  </tbody>
                                </table>
                              </div>

                              {/* Prominent Add Line Item Button - Right Below the table */}
                              {!isReadOnly && (
                                <div className="table-footer-btn-container" onClick={(e) => e.stopPropagation()}>
                                  <button
                                    className="btn btn-secondary btn-block add-line-btn"
                                    onClick={() => handleAddNewLineItemDirect(po)}
                                  >
                                    <Plus size={16} />
                                    Add Line Item
                                  </button>
                                </div>
                              )}

                              {/* Cost Breakdown Summary */}
                              <div className="invoice-totals-summary-row">
                                {(() => {
                                  const totalMaterialCost = calculateTotalCostSum(po.items);
                                  const totalEstimateAmount = calculateProposedClientCharge(po);
                                  const projectedProfit = totalEstimateAmount - totalMaterialCost;
                                  const profitColor = projectedProfit > 0.0001 ? "var(--success)" : projectedProfit < -0.0001 ? "var(--danger)" : "var(--warning)";
                                  return (
                                    <div className="totals-calc-box" style={{ borderLeft: `4px solid ${profitColor}` }}>
                                      <span className="invoice-label">Projected Profit</span>
                                      <span className="totals-val" style={{ color: profitColor, fontWeight: "bold" }}>
                                        {projectedProfit < 0
                                          ? `-$${Math.abs(projectedProfit).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                          : `$${projectedProfit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                      </span>
                                    </div>
                                  );
                                })()}
                                <div className="totals-calc-box margin-left-box">
                                  <span className="invoice-label">Total Material Cost</span>
                                  <span className="totals-val">${calculateTotalCostSum(po.items).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </div>
                                <div 
                                  className="totals-calc-box margin-left-box"
                                  style={{ cursor: isReadOnly ? "default" : "pointer" }}
                                  onClick={() => {
                                    if (!isReadOnly) {
                                      handleOpenShippingCostOutModal(po);
                                    }
                                  }}
                                  title={isReadOnly ? "Shipping Cost Out" : "Click to edit Shipping Cost Out"}
                                >
                                  <span className="invoice-label">Shipping Cost Out</span>
                                  <span className="totals-val">
                                    ${getPoShippingCostOut(po).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </span>
                                </div>
                                <div 
                                  className="totals-calc-box margin-left-box"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleOpenMarkupModal(po)}
                                  title="Click to adjust markup percentage"
                                >
                                  <span className="invoice-label" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    Total Estimate Amount
                                    <span className="sku-badge" style={{ fontSize: "0.65rem", padding: "0.1rem 0.25rem", marginLeft: "0.5rem" }}>
                                      {isCcPayment(po) ? (
                                        `${getPoMarkupRate(po)}% Markup + CC (${getPoCcFee()}%) = ${getEffectivePoMarkupRate(po)}% MARKUP`
                                      ) : (
                                        `${getPoMarkupRate(po)}% Markup`
                                      )}
                                    </span>
                                  </span>
                                  <span className="totals-val charge-total-val">${calculateProposedClientCharge(po).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </div>
                              </div>

                              {/* Action Footer for proposal submission */}
                              <div className="invoice-actions-footer" onClick={(e) => e.stopPropagation()} style={{ gap: "1rem", display: "flex" }}>
                                {po.status === "Bid Submitted" && (
                                  <div style={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%" }}>
                                    <div style={{ display: "flex", gap: "1rem", width: "100%" }}>
                                      <button
                                        className="btn btn-primary"
                                        style={{ flex: 1, backgroundColor: "var(--success)" }}
                                        onClick={() => handleOpenPoStatusChange(po, "Won")}
                                      >
                                        <Award size={18} />
                                        Mark Bid Proposal as Won
                                      </button>
                                      
                                      <div className="close-estimate-dropdown-container" style={{ position: "relative", flex: 1 }}>
                                        <button
                                          type="button"
                                          className="btn btn-danger"
                                          style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}
                                          onClick={() => setActiveCloseMenuId(activeCloseMenuId === po.id ? null : po.id)}
                                        >
                                          <Ban size={18} />
                                          Close / Mark Loss
                                          <ChevronDown size={16} />
                                        </button>

                                        {activeCloseMenuId === po.id && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              bottom: "calc(100% + 4px)",
                                              left: 0,
                                              right: 0,
                                              backgroundColor: "var(--bg-card)",
                                              border: "1px solid var(--border-color)",
                                              borderRadius: "6px",
                                              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
                                              zIndex: 100,
                                              overflow: "hidden",
                                              display: "flex",
                                              flexDirection: "column"
                                            }}
                                          >
                                            {[
                                              { label: "Cancelled", value: "Cancelled" },
                                              { label: "Proposal Lost", value: "Proposal Lost" },
                                              { label: "On Hold", value: "On Hold" },
                                              { label: "Not Granted", value: "Not Granted" }
                                            ].map((opt) => (
                                              <button
                                                key={opt.value}
                                                type="button"
                                                onClick={() => {
                                                  setActiveCloseMenuId(null);
                                                  handleOpenPoStatusChange(po, opt.value);
                                                }}
                                                style={{
                                                  padding: "0.65rem 1rem",
                                                  textAlign: "left",
                                                  background: "transparent",
                                                  border: "none",
                                                  borderBottom: "1px solid rgba(255, 255, 255, 0.05)",
                                                  color: "var(--text-primary)",
                                                  fontSize: "0.85rem",
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "0.5rem"
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)"}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
                                              >
                                                <Ban size={14} style={{ color: opt.value === "On Hold" || opt.value === "Not Granted" ? "var(--warning)" : "var(--danger)" }} />
                                                {opt.label}
                                              </button>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div style={{ display: "flex", gap: "1rem", width: "100%" }}>
                                      <button
                                        className="btn btn-warning"
                                        style={{ flex: 1, color: "var(--bg-card)", display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}
                                        onClick={() => setUpdateBidPo(po)}
                                      >
                                        <RefreshCw size={18} />
                                        Update Bid
                                      </button>
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => handleGeneratePDF(po)}
                                        style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", height: "40px", background: "var(--success)", borderColor: "var(--success)", color: "#000000" }}
                                      >
                                        <FileText size={18} color="#000000" />
                                        Export Bid Proposal PDF
                                      </button>
                                    </div>
                                  </div>
                                )}
                                {po.status === "Update Bid" && (
                                  <div style={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%" }}>
                                    <div className="proposal-final-notice" style={{ backgroundColor: "rgba(255, 193, 7, 0.1)", borderColor: "rgba(255, 193, 7, 0.3)", color: "#ffc107", padding: "0.75rem 1rem", borderRadius: "6px", fontSize: "0.85rem", textAlign: "center" }}>
                                      This bid proposal is currently in <strong>UPDATE BID</strong> status. Modify items as needed and click "Ready to Submit" above to resubmit.
                                    </div>
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => handleGeneratePDF(po)}
                                      style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", height: "40px", background: "var(--success)", borderColor: "var(--success)", color: "#000000" }}
                                    >
                                      <FileText size={18} color="#000000" />
                                      Export Bid Proposal PDF
                                    </button>
                                  </div>
                                )}
                                {["Won", "Lost", "Proposal Lost", "Cancelled", "On Hold", "Not Granted"].includes(po.status) && (
                                  <div style={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%" }}>
                                    {po.changeHistory && po.changeHistory.length > 0 && (
                                      <div style={{ marginTop: "0.5rem", borderTop: "1px solid var(--border-color)", paddingTop: "1rem" }} onClick={(e) => e.stopPropagation()}>
                                        <h4 style={{ fontSize: "0.95rem", color: "var(--primary)", marginBottom: "0.75rem", display: "flex", alignItems: "center", gap: "0.4rem" }}>
                                          <Sliders size={14} />
                                          EST Change History Log
                                        </h4>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem", maxHeight: "250px", overflowY: "auto", paddingRight: "0.5rem" }}>
                                          {po.changeHistory.map((log, lIdx) => (
                                            <div key={lIdx} style={{ backgroundColor: "rgba(255, 255, 255, 0.02)", border: "1px solid var(--border-color)", borderRadius: "6px", padding: "0.75rem" }}>
                                              <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.8rem", color: "var(--text-muted)", marginBottom: "0.5rem" }}>
                                                <span>User: <strong style={{ color: "var(--text-primary)" }}>{log.user}</strong></span>
                                                <span>{new Date(log.timestamp).toLocaleString()}</span>
                                              </div>
                                              <ul style={{ margin: 0, paddingLeft: "1.2rem", fontSize: "0.82rem", color: "var(--text-secondary)" }}>
                                                {log.changes && log.changes.map((change, cIdx) => (
                                                  <li key={cIdx} style={{ marginBottom: "0.25rem" }}>{change}</li>
                                                ))}
                                              </ul>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                    <div className="proposal-final-notice">
                                      This bid proposal has been finalized as <strong>{po.status.toUpperCase()}</strong>.
                                    </div>
                                    <div style={{ display: "flex", gap: "1rem", width: "100%" }}>
                                      {po.status !== "Won" && (
                                        <button
                                          className="btn btn-warning"
                                          onClick={() => setUpdateBidPo(po)}
                                          style={{ flex: 1, color: "var(--bg-card)", display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", height: "40px" }}
                                        >
                                          <RotateCcw size={18} />
                                          Reopen Estimate
                                        </button>
                                      )}
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => handleGeneratePDF(po)}
                                        style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", height: "40px", background: "var(--success)", borderColor: "var(--success)", color: "#000000" }}
                                      >
                                        <FileText size={18} color="#000000" />
                                        Export Bid Proposal PDF
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      
      <POReceiveModal
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setEditingPoId(null);
        }}
        onSubmit={handleSavePOModal}
        newPoForm={newPoForm}
        setNewPoForm={setNewPoForm}
        error={error}
        loading={loading}
        customers={customers}
        paymentMethods={paymentMethods}
        companyLogos={companyLogos}
        existingPos={pos}
        onAddCustomerClick={() => handleOpenAddCustomerModal()}
        isEditMode={!!editingPoId}
      />

      <POMarkupModal
        isOpen={markupModalOpen}
        onClose={() => setMarkupModalOpen(false)}
        markupPo={markupPo}
        tempMarkupRate={tempMarkupRate}
        setTempMarkupRate={setTempMarkupRate}
        error={error}
        onSubmit={handleSavePoMarkup}
      />

      <ShippingCostOutModal
        isOpen={shippingCostOutModalOpen}
        onClose={() => {
          setShippingCostOutModalOpen(false);
          setSelectedShippingPo(null);
        }}
        po={selectedShippingPo}
        shippingCostOut={tempShippingCostOut}
        setShippingCostOut={setTempShippingCostOut}
        submitting={shippingCostOutSubmitting}
        error={shippingCostOutError}
        onSubmit={handleSaveShippingCostOutModal}
      />

      <AdditionalInfoModal
        isOpen={additionalInfoModalOpen}
        onClose={() => { setAdditionalInfoModalOpen(false); setAdditionalInfoPo(null); }}
        po={additionalInfoPo}
        additionalInfo={tempAdditionalInfo}
        setAdditionalInfo={setTempAdditionalInfo}
        error={error}
        onSubmit={handleSaveAdditionalInfo}
      />

      <style>{`
        /* Accordion-specific layouts */
        .clickable-po-row {
          cursor: pointer;
          transition: var(--transition-fast);
        }

        .clickable-po-row:hover td {
          background-color: hsla(var(--hue-primary), 89%, 60%, 0.05);
        }

        .row-expanded-active td {
          background-color: hsla(var(--hue-primary), 89%, 60%, 0.08) !important;
          border-bottom-color: transparent !important;
        }

        .expanded-accordion-row td {
          padding: 0 !important;
          background-color: hsl(var(--hue-bg), 32%, 7%);
          border-bottom: 1px solid var(--border-color);
        }

        .fold-down-container {
          padding: 2rem 2.5rem;
          border-top: 1px solid var(--border-color);
        }

        /* Expanded invoice container */
        .invoice-layout-sheet {
          background-color: var(--bg-card);
          border: 1px solid var(--border-color);
          border-radius: var(--radius-md);
          padding: 2.25rem;
          box-shadow: var(--shadow-sm);
        }

        .invoice-sheet-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border-bottom: 1px solid var(--border-color);
          padding-bottom: 1.25rem;
        }

        .invoice-meta-tag {
          font-size: 0.75rem;
          color: var(--primary);
          letter-spacing: 0.1em;
          font-weight: 700;
          text-transform: uppercase;
        }

        .invoice-project-title {
          font-size: 0.95rem;
          color: var(--text-secondary);
          display: block;
          margin-top: 0.2rem;
        }

        .invoice-label {
          display: block;
          font-size: 0.75rem;
          color: var(--text-muted);
          letter-spacing: 0.05em;
          margin-bottom: 0.25rem;
          text-transform: uppercase;
        }

        .invoice-client-name-bold {
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--text-primary);
          font-family: var(--font-heading);
          margin-bottom: 0.25rem;
        }

        .invoice-meta-detail {
          font-size: 0.85rem;
          color: var(--text-secondary);
        }

        /* Drag column info header */
        .drag-column-info {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          background-color: var(--bg-sidebar);
          border: 1px solid var(--border-color);
          border-left: 3px solid var(--primary);
          padding: 0.65rem 1rem;
          border-radius: 4px;
          margin-top: 1rem;
          font-size: 0.8rem;
          color: var(--text-secondary);
        }

        /* Tooltip style */
        .tooltip-container {
          position: relative;
          display: inline-flex;
          align-items: center;
          cursor: help;
        }

        .tooltip-text {
          visibility: hidden;
          width: 250px;
          background-color: var(--bg-card);
          color: #ffffff;
          text-align: center;
          border-radius: var(--radius-sm);
          padding: 0.5rem 0.75rem;
          position: absolute;
          z-index: 100;
          bottom: 125%;
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          transition: opacity 0.3s, visibility 0.3s;
          border: 1px solid var(--border-color);
          font-size: 0.8rem;
          line-height: 1.4;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
          pointer-events: none;
        }

        .tooltip-text::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: var(--border-color) transparent transparent transparent;
        }

        .tooltip-container:hover .tooltip-text {
          visibility: visible;
          opacity: 1;
        }

        .suggestion-item {
          transition: background-color 0.15s ease;
        }

        .suggestion-item:hover {
          background-color: var(--bg-sidebar);
        }

        /* Draggable TH styling */
        .draggable-th {
          cursor: grab;
          user-select: none;
          transition: border 0.15s, background-color 0.15s;
        }

        .draggable-th:active {
          cursor: grabbing;
        }

        /* Highlight where dragging to */
        th.drag-over {
          border-left: 2px solid var(--primary) !important;
          background-color: hsla(var(--hue-primary), 89%, 60%, 0.15) !important;
        }

        td.drag-over {
          border-left: 2px solid var(--primary) !important;
          background-color: hsla(var(--hue-primary), 89%, 60%, 0.05) !important;
        }

        th.dragging {
          opacity: 0.3;
        }

        /* Invoice Table */
        .invoice-table-wrapper {
          border: 1px solid var(--border-color);
          border-radius: var(--radius-sm);
          overflow-x: auto;
          background-color: var(--bg-sidebar);
          margin-bottom: 0.5rem;
        }

        .invoice-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: auto;
        }

        .invoice-table th {
          background-color: hsla(var(--hue-bg), 24%, 12%, 0.6);
          padding: 0.75rem 0.5rem;
          font-size: 0.8rem;
        }

        .invoice-table td {
          padding: 0.4rem 0.25rem;
          border-bottom: 1px solid var(--border-color);
          font-size: 0.85rem;
          vertical-align: middle;
        }

        .invoice-table tr:last-child td {
          border-bottom: none;
        }

        /* Table footer Add line item button container */
        .table-footer-btn-container {
          margin-top: 0.5rem;
          margin-bottom: 1.5rem;
        }

        .add-line-btn {
          background-color: var(--bg-sidebar);
          border: 1px dashed var(--border-color);
          color: var(--text-secondary);
          height: 38px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
        }

        .add-line-btn:hover {
          background-color: var(--bg-input);
          color: var(--text-primary);
          border-color: var(--primary);
        }

        /* Inline editable input */
        .inline-edit-input {
          background: transparent;
          border: 1px solid transparent;
          outline: none;
          color: inherit;
          width: 100%;
          font-family: inherit;
          font-size: inherit;
          padding: 0.4rem 0.5rem;
          border-radius: 4px;
          transition: background 0.15s, border-color 0.15s;
        }

        .inline-edit-input:disabled {
          color: var(--text-primary);
          cursor: default;
        }

        .inline-edit-input:hover:not(:disabled) {
          background-color: hsla(255, 255, 255, 0.02);
          border-color: var(--border-color);
        }

        .inline-edit-input:focus:not(:disabled) {
          background-color: var(--bg-input);
          border-color: var(--primary);
          box-shadow: 0 0 0 1px var(--border-focus);
          color: var(--text-primary);
        }

        .inline-edit-input.text-center {
          text-align: center;
        }

        .inline-edit-input.text-right {
          text-align: right;
        }

        .invoice-empty-rows {
          text-align: center;
          color: var(--text-muted);
          padding: 2.5rem 1rem !important;
          font-size: 0.9rem;
        }

        .invoice-item-delete {
          background: none;
          border: none;
          color: var(--text-muted);
          cursor: pointer;
          transition: var(--transition-fast);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0.5rem;
          border-radius: 4px;
        }

        .invoice-item-delete:hover {
          color: var(--danger);
          background-color: var(--danger-light);
        }

        .invoice-url-link {
          color: var(--primary);
          display: inline-flex;
          align-items: center;
          padding: 0.4rem;
          border-radius: 4px;
          transition: var(--transition-fast);
        }

        .invoice-url-link:hover {
          color: var(--primary-hover);
          background-color: var(--primary-light);
        }

        /* Totals summary bar */
        .invoice-totals-summary-row {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 1.5rem;
        }

        .totals-calc-box {
          background-color: var(--bg-sidebar);
          border: 1px solid var(--border-color);
          padding: 0.85rem 1.25rem;
          border-radius: var(--radius-sm);
          text-align: right;
          min-width: 160px;
        }

        .margin-left-box {
          margin-left: 1rem;
          border-left: 4px solid var(--primary);
        }

        .totals-val {
          display: block;
          font-size: 1.35rem;
          font-weight: 700;
          font-family: var(--font-heading);
          color: var(--text-primary);
          margin-top: 0.15rem;
        }

        .charge-total-val {
          color: var(--text-primary);
          font-size: 1.6rem;
        }

        /* Actions Footer */
        .invoice-actions-footer {
          display: flex;
          justify-content: center;
          margin-top: 1rem;
          border-top: 1px solid var(--border-color);
          padding-top: 1.25rem;
        }

        .invoice-actions-footer .btn {
          width: 100%;
          height: 44px;
          font-weight: 600;
        }

        .proposal-final-notice {
          width: 100%;
          text-align: center;
          padding: 0.85rem;
          background-color: var(--bg-sidebar);
          border: 1px solid var(--border-color);
          color: var(--text-secondary);
          border-radius: var(--radius-sm);
          font-size: 0.9rem;
        }

        .proposal-final-notice strong {
          color: var(--text-primary);
        }

        .table-actions-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .search-box-container {
          position: relative;
          flex: 1;
          display: flex;
          align-items: center;
        }

        .search-icon {
          position: absolute;
          left: 1rem;
          color: var(--text-muted);
        }

        .search-input {
          padding-left: 2.75rem;
        }

        .filter-select {
          min-width: 180px;
        }

        .sku-badge {
          font-family: var(--font-heading);
          font-weight: 700;
          color: var(--primary);
          background-color: var(--primary-light);
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-size: 0.85rem;
        }

        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 5rem 0;
          gap: 1rem;
          color: var(--text-secondary);
        }

        .spinner-icon {
          animation: spin 1s linear infinite;
        }

        .empty-state-card {
          text-align: center;
          padding: 4rem 2rem;
          background-color: var(--bg-card);
          border: 1px dashed var(--border-color);
          border-radius: var(--radius-md);
        }

        .empty-state-icon {
          color: var(--text-muted);
          margin-bottom: 1rem;
        }

        .empty-state-card h3 {
          margin-bottom: 0.5rem;
          color: var(--text-primary);
        }

        .empty-state-card p {
          color: var(--text-secondary);
          max-width: 320px;
          margin: 0 auto;
          font-size: 0.9rem;
        }

        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @media (max-width: 768px) {
          .table-actions-container {
            flex-direction: column;
            align-items: stretch;
            gap: 1rem;
          }
        }
      `}</style>

      <POAddCustomerModal
        isOpen={addCustomerModalOpen}
        onClose={() => setAddCustomerModalOpen(false)}
        customerForm={customerForm}
        setCustomerForm={setCustomerForm}
        onSubmit={handleCreateCustomer}
        customerCategories={customerCategories}
        paymentMethods={paymentMethods}
        loading={loading}
      />

      <POTagSearchModal
        isOpen={tagSearchModalOpen}
        onClose={() => {
          setTagSearchModalOpen(false);
          setTagSearchTarget(null);
        }}
        tagSearchQuery={tagSearchQuery}
        setTagSearchQuery={setTagSearchQuery}
        availableTags={availableTags}
        availableBrandTags={availableBrandTags}
        selectedSearchTag={selectedSearchTag}
        setSelectedSearchTag={setSelectedSearchTag}
        vendors={vendors}
        onSelectVendor={tagSearchTarget ? handleSelectVendorFromTagSearch : undefined}
      />

      <POUrlModal
        isOpen={urlModalOpen}
        onClose={() => {
          setUrlModalOpen(false);
          setUrlModalTarget(null);
        }}
        initialUrl={urlModalTarget?.initialUrl || ""}
        itemName={urlModalTarget?.itemName || ""}
        vendorName={urlModalTarget?.vendorName || ""}
        onSave={async (newUrl) => {
          if (urlModalTarget) {
            const target = urlModalTarget;
            setUrlModalTarget(null);
            await handleUpdateVendorFieldAndSync(target.poId, target.itemId, target.vendorId, "url", newUrl);
          }
        }}
      />

      <POSubmitBidModal
        isOpen={submitModalOpen}
        onClose={() => setSubmitModalOpen(false)}
        submitPo={submitPo}
        onSubmitBid={handleModalSubmitToClient}
        isSubmitted={isSubmitted}
        onExportPDF={handleGeneratePDF}
        proposedCharge={submitPo ? calculateProposedClientCharge(submitPo) : 0}
        totalMaterialCost={submitPo ? calculateTotalCostSum(submitPo.items) : 0}
        projectedProfit={submitPo ? (calculateProposedClientCharge(submitPo) - calculateTotalCostSum(submitPo.items)) : 0}
        isLowProfit={submitPo ? ((calculateProposedClientCharge(submitPo) - calculateTotalCostSum(submitPo.items)) <= 0.0001) : false}
        isManagerOrAdmin={isManagerOrAdmin}
        managerNote={submitManagerNote}
        setManagerNote={setSubmitManagerNote}
      />

      <POStatusModal
        isOpen={statusUpdateModalOpen}
        onClose={() => setStatusUpdateModalOpen(false)}
        po={statusUpdatePo}
        newStatus={statusUpdateNewStatus}
        awardedDate={awardedDate}
        setAwardedDate={setAwardedDate}
        customerPoNumber={statusCustomerPo}
        setCustomerPoNumber={setStatusCustomerPo}
        onConfirm={handleSaveStatusUpdate}
      />

      <UpdateBidModal
        isOpen={!!updateBidPo}
        onClose={() => setUpdateBidPo(null)}
        poNumber={updateBidPo?.poNumber}
        onConfirm={handleUpdateBidConfirm}
        isReopen={Boolean(updateBidPo && updateBidPo.status !== "Bid Submitted")}
        currentStatus={updateBidPo?.status}
      />

      <POTeamsChatModal
        isOpen={!!selectedChatPo}
        onClose={() => setSelectedChatPo(null)}
        po={selectedChatPo}
      />

      {selectedChangeRequestPo && (
        <ChangeRequestModal
          po={selectedChangeRequestPo}
          onClose={() => setSelectedChangeRequestPo(null)}
        />
      )}

      {selectedTasksPo && (
        <POTasksModal
          isOpen={!!selectedTasksPo}
          po={selectedTasksPo}
          onClose={() => setSelectedTasksPo(null)}
        />
      )}

      <POLineMarkupModal
        isOpen={customMarkupModalOpen}
        onClose={() => {
          setCustomMarkupModalOpen(false);
          setSelectedMarkupItem(null);
          setSelectedMarkupPo(null);
        }}
        item={selectedMarkupItem}
        po={selectedMarkupPo}
        defaultMarkup={selectedMarkupPo ? getEffectivePoMarkupRate(selectedMarkupPo) : 0}
        onSave={handleSaveLineMarkup}
      />

      <DeleteEstimateConfirmationModal
        isOpen={deleteEstimateModalOpen}
        onClose={() => {
          if (!isDeletingEstimate) {
            setDeleteEstimateModalOpen(false);
            setEstimateToDelete(null);
          }
        }}
        onConfirm={handleConfirmDeleteEstimate}
        po={estimateToDelete}
        isDeleting={isDeletingEstimate}
      />

      <POLineNotesModal
        isOpen={lineNotesModal.open}
        onClose={() => setLineNotesModal({ open: false, po: null, item: null })}
        po={lineNotesModal.po}
        item={lineNotesModal.item}
        currentUser={currentUser}
        onSave={handleSaveLineNote}
      />

    </div>
  );
}
